import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedService } from '../Services/shared.service';
import { Observable, Subject, Subscription, catchError, debounceTime, distinctUntilChanged, firstValueFrom, skip, takeUntil, throwError } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MOB_AND_WEB_ENTITIES, SECTION, VALIDATION, WIDGET } from '../../models/app-json';
import { ActivatedRoute, Router } from '@angular/router';
import { PAGEI } from '../../models/page_config_json';
import { ICON_TYPES, WIDGET_ACTIONS_VALIDATIONS, pageTypeCnsts,  WIDGET_TYPES, PAGETYPES, DISPLAY_WIDGETS, ALLOWED_ITEM_FROM_WIDGET_LIST,WIDGET_CLICK_ACTIONS,DROPDOWN_DATASOURCE_FILTERTYPES, ALLOWED_INPUT_WIDGET_TYPES, STANDERD_ADDITIONAL_WIDGETS,ALLOWED_ITEM_FROM_WIDGET_LIST_FOR_DATALISTPAGE} from '../../constants/proj.cnst';
import { APIConfigMapping, HTTPAPIConfig, VlHttpService, isNullOrUndefined,HighchartsRendererService, ImageCropperComponent, CHARTS_LEGEND_ALIGNMENT_MAPPING , ApiconfigService, VlDataService, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS, AppPermissionsPipe, StreamBlobService } from 'shared-library';
import { ToastrService } from 'ngx-toastr';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Clipboard } from '@angular/cdk/clipboard';
import {DATA_BOARD_TYPES, DATA_SOURCE_TYPES, DATALIST_FILE_DOWNLOADTYPES, FILTER_WIDGET_FILTERTYPES, OVERVIEW_TRACKER_STATUSES, PRE_CONFIGURED_APIS} from './constants/const';
import {WidgetPropertyFormService} from './widget-property-form.service'
import { ACCURACIES_CONSTANTS, DATABOARDHEADERTYPES, DATERANGE_CONSTANTS, FILEUPLOADER_CONSTANTS, IMGVIDPICKER_CONSTANTS, MAT_UI_TYPES } from '../../constants/widgets_props_cnst';
import { MatSelectChange } from '@angular/material/select';
import { MediaComponent } from '../media/media.component';
import { PageRearrangeService } from '../mobi-pages/services/page-rearrange.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'lib-widget-property-forms',
  templateUrl: './widget-property-forms.component.html',
  styleUrls: ['./widget-property-forms.component.scss'],
  providers:[AppPermissionsPipe],
  animations: [
    trigger('sidenavFadInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-100px)' }),
        animate('200ms', style({ opacity: 1, transform: 'translateX(0px)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateX(0px)' }),
        animate('200ms', style({ opacity: 0, transform: 'translateX(-100px)' }))
      ])
    ])
  ]
})
export class WidgetPropertyFormsComponent implements OnInit, OnDestroy {
  pageId!:string;
  openedContainers: string[] = [];
  page: PAGEI = { pageId: "", pageName: "", applicationId: '' };
  displayedContent!: string;
  displaySubNav: boolean = false;
  colorCtr!: FormGroup;
  panelOpenState = true;
  selectedComponents: any[] = [];
  selectedWidgetTypeConfig!: string;
  selectedWidgetMetaData: any = { widgetId: '', key: '', name: '', widgetType: '', style: {}, showDeleteButton: false, customStyleApplied: false ,widgetConfig:{}};
  selectedColor!: string;
  selectedBgColor!: string;
  openedWidgetForm!: number;
  isClicked: boolean = false;
  dataSourceValues: string[] = [];
  dataSourceApi: any;
  subFormActionsList: any[] = []
  /** form groups for widget properties  */
  textGroup!: FormGroup;
  textFieldGroup!: FormGroup;
  filePickerGroup!: FormGroup;
  imagePickerGroup!: FormGroup;
  selectGroup!: FormGroup;
  buttonGroup!: FormGroup;
  printerGroup!: FormGroup;
  navButtonGroup!: FormGroup;
  FormbuttonGroup!: FormGroup;
  checkBoxGroup!: FormGroup;
  radioButtonGroup!: FormGroup;
  sectionGroup!: FormGroup;
  definedFormGroup!: FormGroup;
  sectionWidgetGroup!: FormGroup;
  dataPickerGroup!: FormGroup;
  widgetTypes: any = WIDGET_TYPES;
  widgetClickActionTypes:any = WIDGET_CLICK_ACTIONS;
  displayWidgets = DISPLAY_WIDGETS;
  iconTpes: any = ICON_TYPES;
  databoardHeaderTypes = DATABOARDHEADERTYPES;
  dataBoardTypes = DATA_BOARD_TYPES;
  overviewTrackerStatuses = OVERVIEW_TRACKER_STATUSES;
  filterWidgetFilterTypes = FILTER_WIDGET_FILTERTYPES;
  pageTypes = PAGETYPES;
  pagesList: any[] = [];
  formsList: any[] = [];
  widgetMetaEntire: any;
  apiForm!: FormGroup;
  dropdownDatasourceEntityForm!: FormGroup;
  valuesForm!: FormGroup;
  dataSourceTypeForm!: FormGroup;
  showMenuGroup!: FormGroup;
  singleInputField!: FormGroup;
  dataSourceTypes = ['API', 'Manual', 'Stage','Entity'];
  hasMenu: boolean = false;
  pageIndex!: number;
  imageUploaderSrc = '../assets/images/image-placeholder.webp';
  defaultImgSrc = '../assets/images/image-placeholder.webp';
  imageUploaderPhoto!: File;
  lableExisted: boolean = false;
  editedlableExisted: boolean = false;
  fieldWigets!: any[];
  conditionalFormList: any[] = [];
  pageNamesandIdList: any[] = [];
  pageNames: any[] = [];
  needConditions: boolean = false;
  apikeys: any[] = [];
  scannerGroup!: FormGroup;
  separatorGroup!: FormGroup;
  geoGroup!: FormGroup;
  geoFenceGroup!: FormGroup;
  addressGroup!: FormGroup;
  authApiuserCreds!: FormGroup;
  authApiEmailCreds!: FormGroup;
  previewGroup!: FormGroup;
  dataListGroup!: FormGroup;
  AuthApiGroup!: FormGroup;
  imageUploaderGroup!: FormGroup;
  faceIdGroup!: FormGroup;
  touchIdGroup!: FormGroup;
  itemForm!: FormGroup;
  selectedApiGroup!:FormGroup;
  chatViewgroup!:FormGroup;
  navTextGroup!:FormGroup;
  dataBoardGroup!:FormGroup;
  overviewTrackerGroup!:FormGroup;
  trackerColorGroup!:FormGroup;
  filterGroup!:FormGroup;
  filterUpdateGroup!:FormGroup;
  selectedPageData: any = {};
  menupaneldetails: any = {};
  checkActualMenu: boolean = false;
  actualpageDetails: any = {};
  /** */
  applicationId: any = '';
  authApikeys: any[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  fieldCtrl = new FormControl('');
  dataField = new FormControl('');
  filteredmsFieldslist: any[] = [];
  msFieldslist: any[] = [];
  msFieldslistnew: any[] = [];
  formWidgetsUpdate: any[] = [];
  msFieldslistUpdate: any[] = []
  conditionalKeyValue: any[] = [];
  dropdownValuesUpdateChip: any[] = [];
  formWidgetsMenuUpdate: any[] = [];

  addOnBlur = true;
  typeApi = false;
  showRadioValueError: string = "";
  dropdownValues: any[] = [];
  selectedField: any;
  showAuthUrlError: boolean = false;

  datalistKeys: string[] = [];
  showEditOption: boolean = false;
  dataListDummyData: any = {
  };
  dataLoading:boolean = false;

  filterWidgetList:any = [];
  csWidgetsList: any[] = [];
  actionForm !: FormGroup;
  showRadioErrorMessage: any[] = [];
  themeData:any;

  dataListWidgetSelectAllToggle:boolean = false;
  validPages: any[] = [];
  
  //charts
  chartDetailsFormGroup!: FormGroup;
  legendAlignmentOptions = CHARTS_LEGEND_ALIGNMENT_MAPPING;
  chartDataSourceTypes = DATA_SOURCE_TYPES;
  subscrptions: Subscription[] = [];
  listOfEntitiesOfMobAndWebApplication!: MOB_AND_WEB_ENTITIES[];
  apiDataSourceApiConfigForm!:FormGroup;
  userApis!:any;
  authApis!:any;
  apis:any = [];

  @ViewChild('payloadInput') payloadInput!: ElementRef<HTMLInputElement>;
  @ViewChild('dropdownAutoDropdown') dropdownAutoDropdown!: MatAutocomplete;
  @ViewChild('dropdownAutoRadio') dropdownAutoRadio!: MatAutocomplete;
  @ViewChild('dropdownAutoCheckBox') dropdownAutoCheckBox!: MatAutocomplete;
  searchTerm: string = '';
  panelStates: boolean[] = [false, false, false, false, false];
  isFilterApplied: boolean = false;
  selectedSectionData: SECTION = { sectionId: "", key: '', name: "", image: "", widgets: [], isEditable: true, showDeleteButton: true, sectionType: '' };
  widgetId: any;
  sectionIndex: any;
  widgetIndex: any;
  label: any;
  formWidgets: any[] = [];
  formWidgetsMenu: any[] = [];
  authApiStatus: any;
  authResposeData: any;
  authApiData: any = {};
  listOfEntitiesOfApplication: any[] = [];
  listOfWidgetsOfEntity: any=[];
  pageIdsOfAssociatedEntity: any[] = [];
  isEntityTouched : boolean = false
  previewPageId!: string;
  widgetActionsandValidations : any = WIDGET_ACTIONS_VALIDATIONS;
  isRhsclicked: boolean = false;
  isLhsclicked: boolean = false;
  isLabelEmpty: boolean = false;
  editMode: boolean = false;
  editedDataSourceValue: any;
  selectedDataSourceIndex : any
  pageName: any;
  fileTypes =  FILEUPLOADER_CONSTANTS.FILE_FORMATS
  imageFormats = IMGVIDPICKER_CONSTANTS.IMAGE.FORMATS;
  videoFormats = IMGVIDPICKER_CONSTANTS.VIDEO.FORMATS;
  dateFormats = DATERANGE_CONSTANTS.DATE_FORMATS
  imageToggles = IMGVIDPICKER_CONSTANTS.IMAGE.TOGGLES
  videoToggles = IMGVIDPICKER_CONSTANTS.VIDEO.TOGGLES;
  fileToggles = FILEUPLOADER_CONSTANTS.TOGGLES;
  matUiTypes = MAT_UI_TYPES;
  isDataListViewPageCreating: boolean = false;
  dateRangeToggles = DATERANGE_CONSTANTS.TOGGLES;
  accuracies = ACCURACIES_CONSTANTS;
  datalistDownloadFileTypes = DATALIST_FILE_DOWNLOADTYPES;
  s3ImageUrl:string = '';
  blobUrl:any = null;
  loading:boolean = true;
  spinnerActive:boolean = false;
  chatBotConfigurationForm!: FormGroup;
  defaultAvtarImageUrl: string | ArrayBuffer | null = 'assets/imgs/chat-boat-avator-pic.png';
  entityList: any[] = [];
  workFlowList: any[] = [];
  workFlowNameList: any[] = [];
  workFlowDataList: any[] = [];
  stageDataList: any[] = [];
  widgetChange:boolean = true;
  preConfiguredApis:any = PRE_CONFIGURED_APIS;
  dataBoardEntityBasedWidgets:any = [];
  filterBasedOnfiledWidgetOptions:any = [];
  predefinedSelected:boolean = false;
  //datalist download 
  downloadPdfSequencelist : string[] = []
  currentWidgetPreviewPageExits : boolean = false;
  //dropdowndatasource
  entitiesWidgetsMaping:any = {};
  entitiesWidgetsMappingObj:any = {}
  dropdownDataSourceFilterTypes = DROPDOWN_DATASOURCE_FILTERTYPES;
  dropdownDataSourceFiltersMenu = [this.dropdownDataSourceFilterTypes.manual,this.dropdownDataSourceFilterTypes.widget];
  toggleActionsAndValidations:boolean = true;
  cachedCombinedItems: any[] = [];
  rhslhslastInputs: string = '';
  destroy$:Subject<void> = new Subject<void>();

    appPermissions = APP_BUILDER_PERMISSIONS;
    permissionsActions = PERMISSIONS_ACTIONS;

    enableUpdate:boolean = false;

  constructor(
    private sharedService: SharedService,private route: ActivatedRoute, private router: Router,private _formBuilder:FormBuilder,
    private cdRef: ChangeDetectorRef, private dataService: VlDataService, private toasterService:ToastrService,private http: HttpClient,
    private httpService: VlHttpService,public dialog: MatDialog,private highchartService:HighchartsRendererService, 
    private clipboard: Clipboard,private wformService:WidgetPropertyFormService,private apiConfigService:ApiconfigService,private appPermissionsPipe:AppPermissionsPipe,private pageRearrangeService:PageRearrangeService, private streamBlobService:StreamBlobService) {
  }

  ngOnInit() {
    this.formbuilder();
    
    this.enableUpdate = this.appPermissionsPipe.transform([this.appPermissions.editPage,this.permissionsActions.edit]);
    
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.pageId = params['pageId'];
      this.applicationId = params['id']
    });

    if (this.pageId !== undefined) {
      this.sharedService.pageData$.pipe(takeUntil(this.destroy$)).subscribe((pageName) => {
        this.pageName = pageName;
      });
      this.editMode = false;
    }

    this.fetchDataListKeys();
    this.themeData = this.sharedService.getThemeData();
    this.sharedService.pages1$.pipe(takeUntil(this.destroy$)).subscribe((pages) => {
      this.pageNamesandIdList = [];
      this.pagesList = pages;
      const order = this.sharedService.getApplicationDataEntire()['page_ids_list']
      if(order){
        pages = this.pageRearrangeService.rearrangePages(pages,order);
      }
      const excludedPageTypes = [PAGETYPES.loginPage, PAGETYPES.splashScreen, PAGETYPES.previewPage, PAGETYPES.dataListView];
      this.validPages = pages.filter((page: any) => !excludedPageTypes.includes(page.pageType));
      pages.forEach((page) => {
        if (page.pageId !== this.pageId && !excludedPageTypes.includes(page.pageType || '')) {
          this.pageNamesandIdList.push({
            label: page.pageName,
            key: page.pageId,
          });
          this.pageNames.push(page.pageName);
        }
      })
      this.pageIndex = pages.findIndex((page: any) => page.pageId === this.pageId);
    })
    this.fetchEntities();

    this.sharedService.selectedPageObj$.pipe(takeUntil(this.destroy$)).subscribe((pageMeta: any) => {
      this.selectedPageData = pageMeta;
      this.selectedComponents = pageMeta.forms;
      if (pageMeta.forms) {
        this.conditionalFormList = [];
        this.formsList = [];
        pageMeta.forms.forEach((form: any) => {
          this.formsList.push({ label: form.formLabel, key: form.formKey });
          this.conditionalFormList.push(form.formLabel);
        })
      }
      this.page = pageMeta;
      pageMeta.forms.forEach((form: any) => {
        if (form?.formConfig?.formType === 'menuPanel') {
          this.hasMenu = true;
          this.menupaneldetails = form;
        }
      })
    })

    this.preLoaders()
    const widgetClickSubscription: any = this.sharedService.onMobileScreenDropSubjectdata$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data?.onClick) {
        this.widgetMetaEntire = data;
        this.displayedContent = data?.widgetMeta?.widgetType;
        this.widgetId = data?.data;
        this.sectionIndex = data?.sectionIndex;
        this.widgetIndex = data?.widgetIndex
        this.panelOpenState = true;
        this.selectedWidgetMetaData = data?.widgetMeta;
        this.selectedWidgetTypeConfig = data?.widgetMeta.type; 
        this.selectedColor = data?.widgetMeta?.widgetConfig?.style?.color;
        this.selectedBgColor = data?.widgetMeta?.style?.backgroundColor;
        if(this.selectedWidgetMetaData.widgetType === WIDGET_TYPES.fixedBarChart) {
          const fixedBarChartSubForm = this._formBuilder.group({
            label1: [],
            series1: [],
            label2: [],
            series2: [],
            yAxis1SeriesProperties: this._formBuilder.array([]),
            yAxis2SeriesProperties: this._formBuilder.array([]),
          });
          this.chartDetailsFormGroup.addControl('fixedChartYAxisProperties', fixedBarChartSubForm)
          this.chartDetailsFormGroup.removeControl('yAxisProperties');
        } else {
          let yAxisProperties = this._formBuilder.group({
            label: [],
            series: [],
            individualSeriesProperties: this._formBuilder.array([]),
            dataLabels:[],
            stackLabels:[]
          })
          this.chartDetailsFormGroup.addControl('yAxisProperties', yAxisProperties)
          this.chartDetailsFormGroup.removeControl('fixedBarChartSubForm');
        }
        this.widgetChange = true;
        this.apikeys = [];
        this.predefinedSelected = false;
        this.csWidgetsListSetter();
        this.widgetsValuePatcher(this.selectedWidgetMetaData);
        //for dataSource 
        if (isNullOrUndefined(this.selectedWidgetMetaData.widgetDataSource?.datasourceType)) {
          this.dataSourceValues = [];
          this.dataSourceApi = [];
        } else {
          this.dataSourceValues = [];
          if (this.selectedWidgetMetaData.widgetDataSource.datasourceType === 'API') {
            this.dataSourceApi = this.selectedWidgetMetaData.widgetDataSource.datasource.map((item: any) => item.label);
          } else if (this.selectedWidgetMetaData.widgetDataSource.datasourceType === 'manual') {
            this.showRadioErrorMessage = this.selectedWidgetMetaData.widgetDataSource.datasource.map((ele: any) => false);
            this.dataSourceValues = this.selectedWidgetMetaData.widgetDataSource.datasource.map((item: any) => item.label);
          } else if (this.selectedWidgetMetaData.widgetDataSource.datasourceType === 'stage') {
          }
        }
        this.toggleActionsAndValidations = false;
        setTimeout(() => {
          this.toggleActionsAndValidations = true;
        },1)
      }
    })

    const buttonUiTypeSub  = this.buttonGroup.get('matUiType')?.valueChanges.pipe(debounceTime(300),takeUntil(this.destroy$)).subscribe((value : any)=> {
      if(!this.selectedWidgetMetaData.widgetConfig.customStyleApplied){
        if(value == this.matUiTypes.outlined ){
          this.buttonGroup.patchValue({
            bgColor:this.themeData.themeName.toLocaleLowerCase().includes('dark') ? '#c3c2d9' : '#87858e',
            textColor:this.selectedWidgetMetaData.widgetConfig.style.backgroundColor,
          },{emitEvent:false,onlySelf:true});
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = this.selectedWidgetMetaData.widgetConfig.style.backgroundColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = this.themeData.themeName.toLocaleLowerCase().includes('dark') ? '#c3c2d9' : '#87858e';
        }else if(value == this.matUiTypes.filled){
          this.buttonGroup.patchValue({
            bgColor:this.themeData.primaryColor,
            textColor:this.themeData.secondaryColor,
          },{emitEvent:false,onlySelf:true});
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = this.themeData.secondaryColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = this.themeData.primaryColor;
        }
      }
    })

    const printerUiTypeSub  = this.printerGroup.get('matUiType')?.valueChanges.pipe(debounceTime(300),takeUntil(this.destroy$)).subscribe((value : any)=> {
      if(!this.selectedWidgetMetaData.widgetConfig.customStyleApplied){
        if(value == this.matUiTypes.outlined ){
          this.printerGroup.patchValue({
            bgColor:this.themeData.themeName.toLocaleLowerCase().includes('dark') ? '#c3c2d9' : '#87858e',
            textColor:this.selectedWidgetMetaData.widgetConfig.style.backgroundColor,
          },{emitEvent:false,onlySelf:true});
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = this.selectedWidgetMetaData.widgetConfig.style.backgroundColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = this.themeData.themeName.toLocaleLowerCase().includes('dark') ? '#c3c2d9' : '#87858e';
        }else if(value == this.matUiTypes.filled){
          this.printerGroup.patchValue({
            bgColor:this.themeData.primaryColor,
            textColor:this.themeData.secondaryColor,
          },{emitEvent:false,onlySelf:true});
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = this.themeData.secondaryColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = this.themeData.primaryColor;
        }
      }
    })
    
    this.subscrptions = this.subscrptions.concat([widgetClickSubscription,buttonUiTypeSub]);
    this.subscrptions = this.subscrptions.concat([widgetClickSubscription,printerUiTypeSub]);
    this.displayWidgetsSubscribeEvents();
    this.changeSubscribe();
    this.cdRef.detectChanges();
  }

  //subscriberEvents
  preLoaders(){
    this.userApis = this.apiConfigService.getUserApis().apis;
    this.authApis = this.apiConfigService.getUserApis().authTypeApis;
    this.apis = [{name:'Configured', apis:this.userApis},{name:'Pre-configured',apis:this.preConfiguredApis}]
  }

  displayWidgetsSubscribeEvents() {
    const dataSourceApiConfigForm = this.apiDataSourceApiConfigForm;
    const headerParamsSubscription: any = dataSourceApiConfigForm.get('headerParamsRequired')?.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(),takeUntil(this.destroy$))
      .subscribe((isRequired: boolean) => {
        if (isRequired) {
          this.headers.push(this.addHeaders())
        }
      });
    
    this.subscrptions.push(headerParamsSubscription);
    this.subscribeToFormValueChanges(this.chartDetailsFormGroup);


    //value changes
    this.chartDetailsFormGroup.get('dataSourceType')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if(value === 'api'){
        this.selectedApiGroup.get('selectedApi')?.setValidators(Validators.required);
        this.chartDetailsFormGroup.get('entity')?.setValidators(null);
      }else{
        this.chartDetailsFormGroup.get('entity')?.setValidators(Validators.required);
        this.selectedApiGroup.get('selectedApi')?.setValidators(null);

      }
    })
  }

  async fetchEntities(){
    this.entityList = await this.sharedService.fetchEntity(this.applicationId,'application');
  }

  subscribeToFormValueChanges(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);

      if (control instanceof FormGroup) {
        this.subscribeToFormValueChanges(control);
      } else {
        const valueChangeSubscription: any = control?.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged(),takeUntil(this.destroy$))
        .subscribe(value => {
          switch (controlName) {
            case 'title' :
                this.selectedWidgetMetaData.widgetLabel =  isNullOrUndefined(this.chartDetailsFormGroup.get('title')?.value) ? 'component': this.chartDetailsFormGroup.get('title')?.value;
              break;
            case 'series': this.formatTheSeriesPropertiesFormArray(value)
              break;
            case 'series1' : this.formatFixeBarYAxisProperties(value, this.yAxis1SeriesProperties)
              break;
            case 'series2' : this.formatFixeBarYAxisProperties(value, this.yAxis2SeriesProperties)
            break;

            default: break;
          }
          this.selectedWidgetMetaData.widgetConfig.chartConfig = this.chartDetailsFormGroup.value; 
          this.highchartService.SetUpdatedDisplayWidgetDataConfig(true);            
        });
        this.subscrptions.push(valueChangeSubscription);
      }
    });
  }

  formatTheSeriesPropertiesFormArray(value: string[]) {
    for (let i = this.individualSeriesProperties.length - 1; i >= 0; i--) {
      const control = this.individualSeriesProperties.at(i) as FormControl;
      if (!value.includes(control.value?.key)) {
        this.individualSeriesProperties.removeAt(i);
      }
    }
    value?.forEach(item => {
      const containsItem = this.individualSeriesProperties.value.some((val: { label: string, key: string }) => val.key === item);
      if (!containsItem) {
        this.individualSeriesProperties.push(
          this._formBuilder.group({
            label: [],
            key: item,
            color: ['#0000FF']
          })
        );
      }
    });
  }

  formatFixeBarYAxisProperties(value: string[], seriesProperties : any) {
    for (let i = seriesProperties.length - 1; i >= 0; i--) { 
      const control = seriesProperties.at(i) as FormControl;
      if (!value.includes(control.value?.key)) {
        seriesProperties.removeAt(i);
      }
    }
    value?.forEach(item => {
      const containsItem = seriesProperties.value.some((val: { label: string, key: string }) => val.key === item);
      if (!containsItem) {
        seriesProperties.push(
          this._formBuilder.group({
            label: [],
            key: item,
            color: ['#0000FF']
          })
        );
      }
    });
  }

  addApiHeaderParams() {
    this.headers.push(this.addHeaders())
  }

  addHeaders(): FormGroup {
    return this._formBuilder.group({
      key: [],
      value: []
    });
  }

  deleteHeader(index: number) {
    this.headers.removeAt(index);
  }

  addApiPostParams() {
    this.apiPostData.push(this.addHeaders());
  }

  deletePostParam(index: number) {
    this.apiPostData.removeAt(index);
  }

  async getActualPage() {
    this.actualpageDetails = await this.sharedService.getPageById(this.selectedPageData.pageId)
      .toPromise();
    this.checkMenuExists();
  }

  //#region  parameters field


  csWidgetsListSetter() {
    if (this.selectedComponents[this.sectionIndex]?.widgets) {
      this.csWidgetsList = this.selectedComponents[this.sectionIndex].widgets.filter((widget: any) => widget.widgetType !== 'button');
    }
  }


  //#endregion

  //#region dataList widget 

  get lhsItems() {
    return this.dataListGroup.get('lhsItems') as FormArray;
  }

  get rhsItems() {
    return this.dataListGroup.get('rhsItems') as FormArray;
  }

  get sortFieldsMapping() {
    return this.dataListGroup.get('sortConfig') as FormArray;
  }

  // Add this helper method to safely retrieve the label
  getCombinedWidgetLabel(field: string): string {
    const item = this.combinedItems?.find(item => item.widgetId === field);
    return item?.widgetLabel || field;
  }

  fetchDataListKeys(): void {
    //   if(Array.isArray(data)) {
    //     return Object.keys(data[0]);
    //  }
    //  else{
    this.datalistKeys = Object.keys(this.dataListDummyData);
    //  }
  }


  //#endregion

  ngOnDestroy() {
    this.collapseMenu();
    this.downloadPdfSequencelist = [];
    this.unsubscribeAllSubscriptions();
    this.destroy$.next();
    this.destroy$.complete();
  }

  unsubscribeAllSubscriptions() {
    this.subscrptions?.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    })
  }

  // for button ______________________--------------------____________

  formbuilder() {

    this.selectedApiGroup = this._formBuilder.group({
      selectedApi:[]
    })

    this.textGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [,[Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      align: [],
      linkEntityId:[],
      linkWidgetId:[],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      fontSize: [0, [Validators.min(0)]],
    });

    this.navTextGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [],
      });

    this.dataPickerGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: ['',[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0,
      dateRangeEnable : false,
      dateFormat : ['',[Validators.required]],
      historicalDays: [0,[Validators.required,Validators.min(0)]],
      futureDays:[0,[Validators.required,Validators.min(0)]],
    });

    this.textFieldGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      type: [],
      allowNegative:[],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      placeholder: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.sectionWidgetGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      type: [],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      placeholder: []
    });

    this.selectGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: [,[Validators.required]],
      type: [],
      placeholder: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.filePickerGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0,
      fileType : [,[Validators.required]],
      maxSize : [,[Validators.required,Validators.min(1)]],
      previewFile : [false],
      fileCompression: [true]

    });

    this.imagePickerGroup = this._formBuilder.group({
      key: [],
      textColor: ['#000000'],
      matUiType: [],
      label: [, [Validators.required]],
      marginTop: [5, [Validators.pattern(/^-?\d+$/)]],
      uploadType: ['', [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0,
      // Image-specific properties
      allowedTypes: ['', [Validators.required]],
      maxSize: ['',[Validators.required,Validators.min(1)]],
      Compression: [true],
      GalleryUpload:[false],
      GeoReference:[false],
      baringToggle:[false],
      gpsAccuracy:[''],
    });
    
    this.buttonGroup = this._formBuilder.group({
      key: [],
      matUiType: [],
      textColor: [],
      label: [,[Validators.required]],
      bgColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: [0, [Validators.min(0)]],
    });

    this.printerGroup = this._formBuilder.group({
      key: [],
      matUiType: [],
      textColor: [],
      label: [,[Validators.required]],
      image:[,[Validators.required]],
      bgColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
    });

    this.navButtonGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      image: [],
      connectedWorkerApplicationId: [],
      connectedWorkerCustomerId:[]
    });
    this.showMenuGroup = this._formBuilder.group({
      showMenu: false,
    })

    this.FormbuttonGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [],
      bgColor: [],
      width: [],
    });

    this.checkBoxGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.radioButtonGroup = this._formBuilder.group({
      key: [],
      title: [,[Validators.required]],
      textColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      value1label: [],
      value2label: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.imageUploaderGroup = this._formBuilder.group({
      key: [],
      marginTop: [2, [Validators.required,Validators.pattern(/^-?\d+$/)]],
    })

    this.faceIdGroup = this._formBuilder.group({
      key: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
    })

    this.touchIdGroup = this._formBuilder.group({
      key: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
    })

    this.sectionGroup = this._formBuilder.group({
      key: [],
      label: [,[Validators.required]],
      bgColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    })

    this.definedFormGroup = this._formBuilder.group({
      bgColor: []
    })


    this.apiForm = this._formBuilder.group({
      needAuth: false,
      apiId: ['',  Validators.required],
      apiUrl: ['', Validators.required],
      method: ['', Validators.required],
      payload: [],
      responseParameter: [],
      authApiUrl: [''],
      auth: [''],
      apiKey: [''],
    });

    this.dropdownDatasourceEntityForm = this._formBuilder.group({
      entityId:[,Validators.required],
      widgetId:[,Validators.required],
      widgetKey:[''],
      basedEntitys:[],
      basedWidgetIds:this._formBuilder.array([]),
      filters:this._formBuilder.array([]),
      operator:[],
    })

    this.AuthApiGroup = this._formBuilder.group({
      authApiUrl: ['', Validators.required],
      auth: ['', Validators.required],
      apiKey: [''],
    })
    this.previewGroup = this._formBuilder.group({
      preview: []
    })

    this.authApiuserCreds = this._formBuilder.group({
      authUsername: [, Validators.required],
      authPassword: [, Validators.required]
    });

    this.authApiEmailCreds = this._formBuilder.group({
      authEmail: [, Validators.required],
      authPassword: [, Validators.required]
    })

    this.valuesForm = this._formBuilder.group({
      label: ['', Validators.required]
    });

    this.dataSourceTypeForm = this._formBuilder.group({
      dataSourceType: ['', Validators.required],
    });

    this.singleInputField = this._formBuilder.group({
      value: ['', Validators.required],
    });


    this.scannerGroup = this._formBuilder.group({
      key: [],
      label: [,[Validators.required]],
      placeholder: [],
      matUiType: [],
      textColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.separatorGroup = this._formBuilder.group({
      key: [],
      thickness: [5, [Validators.required, Validators.min(1)]],
      textColor: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
    });
    this.chatViewgroup = this._formBuilder.group({
      key: [],
      label:[,[Validators.required]],
      isLogo: [],
    });
    this.geoGroup! = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    })
    this.geoFenceGroup! = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [,[Validators.required]],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0,
      geofenceTypes : ['',Validators.required],
      geofenceShape : ['',Validators.required]
    })

    this.addressGroup = this._formBuilder.group({
      key: [],
      matUiType: [],
      textColor: [],
      label: [,[Validators.required]],
      placeholder: [],
      marginTop: [5,[Validators.pattern(/^-?\d+$/)]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.dataListGroup = this._formBuilder.group({
      key: [],
      type: ['',Validators.required],
      entity: ['',Validators.required],
      entryPageId:[''],
      workflow: [''],
      stage: [''],
      groupBy: [''],
      mysubmission: [false, Validators.required],
      edit: [false, Validators.required],
      search: [false, Validators.required],
      filter: [false, Validators.required],
      filterFormId:[''],
      download: [false, Validators.required],
      downloadType:[],
      sort: [false, Validators.required],
      defaultSortType: ['desc'],
      defaultSortField: [['created_date'],],
      sortFields: [],  
      sortConfig:  this._formBuilder.array([]),
      widgets:[],
      fileType:[],
      delete: [false, Validators.required],
      lhsItems: this._formBuilder.array([]),
      rhsItems: this._formBuilder.array([]),
      textColor: '',
      marginTop: [5],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.dataBoardGroup = this._formBuilder.group({
      key: [],
      label:[,Validators.required],
      type:[,Validators.required],
      // filter: [false, Validators.required],
      download: [false],
      downloadType:[],
      widgets:[],
      fileType:[],
      serialNumber:[false,Validators.required],
      dataSource:[,Validators.required],
      entityId:[,Validators.required],
      widgetId:[],
      primary:[,Validators.required],
      customLabels:[],
      lhsItemsCustomLabel:[],
      secondary: [],
      maxRows:[],
      headertype:[,Validators.required],
      // groupBy: [],
      customHeader:[],
      aggregate:[],
      search:[]
    });

    this.overviewTrackerGroup = this._formBuilder.group({
      key: [],
      label:[,Validators.required],
      serialNumber:[false,Validators.required],
      dataSource:[,Validators.required],
      statusLabel:[,Validators.required],
      statuses:[,Validators.required],
      entityId:[,Validators.required],
      widgetId:[],
      primary:[,Validators.required],
      secondary:[],
      statusesColorCode:[],
      legend:[],
      info:[],
      infoDescription:[],
      search:[]
    })

    this.filterGroup = this._formBuilder.group({
      filterType:[,Validators.required],
      label:[,Validators.required],
      sourceType:[,Validators.required],
      dataSource:[,Validators.required],
      basedOn:[,Validators.required],
      appliesTo:[],
      manual:[],
      manualValues:[],
    })

    this.filterUpdateGroup = this._formBuilder.group({
      filterType:[,Validators.required],
      label:[,Validators.required],
      sourceType:[,Validators.required],
      dataSource:[,Validators.required],
      basedOn:[,Validators.required],
      appliesTo:[],
      manual:[],
      manualValues:[],
    })

    this.chartDetailsFormGroup = this._formBuilder.group({
      key: [],
      title: [],
      description: [],
      dataSourceType: [],
      entity: [],
      primary:[],
      secondary:[],
      xAxisProperties: this._formBuilder.group({
        label: [],
        categories: []
      }),
      yAxisProperties: this._formBuilder.group({
        label: [],
        series: [],
        individualSeriesProperties: this._formBuilder.array([]),
        dataLabels:[],
        stackLabels:[]
      }),
      legendPropertyies: this._formBuilder.group({
        displayLegend: [],
        legendAlignment: [1,],
      })
    })

    this.apiDataSourceApiConfigForm = this._formBuilder.group({
      apiUrl: [],
      httpMethod: [],
      headerParamsRequired: [false],
      headers: this._formBuilder.array([]),
      apiPostData: this._formBuilder.array([])
    })

    this.chatBotConfigurationForm = this._formBuilder.group({
      textColor: [],
      bgColor: [],
      panelWidth: [],
      panelHeight: [400,Validators.min(400)],
      footerButtonColor: [],
      footerTextColor: [],
      footerBorderColor: [],
      avatarShape: [],
      uploadedAvatar: [],
      avatarFileName: [],
      userAvatar: [],
      showAttachmentsIcon: [true],
      showSendIcon: [true],
      showSpeechIcon: [true],
      showTextInput: [true]
    })

    this.initializeMenuPanelForm();
  }

  get individualSeriesProperties() {
    return (this.chartDetailsFormGroup.get('yAxisProperties') as FormGroup)?.get('individualSeriesProperties') as FormArray;
  }

  get yAxis1SeriesProperties(){
    return (this.chartDetailsFormGroup.get('fixedChartYAxisProperties') as FormGroup)?.get('yAxis1SeriesProperties') as FormArray;
  }

  get yAxis2SeriesProperties(){
    return (this.chartDetailsFormGroup.get('fixedChartYAxisProperties') as FormGroup)?.get('yAxis2SeriesProperties') as FormArray;
  }

  get headers() {
    return this.apiDataSourceApiConfigForm.get('headers') as FormArray;
  }

  get apiPostData() {
    return this.apiDataSourceApiConfigForm.get('apiPostData') as FormArray;
  }

  async widgetsValuePatcher(widget: any) {
    let textColor = (widget.widgetConfig.style as any)?.['color'] || '';
    let bgColor = (widget.widgetConfig.style as any)?.['backgroundColor'] || '';
    let width = (widget.widgetConfig.style as any)?.['width'] || '';
    let marginTop = (widget.widgetConfig.style as any)?.['margin-top'] || '5px';
    let align = (widget.widgetConfig.style as any)?.['text-align'] || 'left';
    let placeholder;
    let label;
    const additionalConfig = widget.widgetConfig?.additionalConfig

    if (widget.element) {
      label = widget.element.label;
      placeholder = widget.element.placeholderText;
    }
    switch (widget.widgetType) {
      case this.widgetTypes.plainText:
        this.textGroup.reset({},{emitEvent: false});
        if(widget.widgetConfig.additionalConfig['linkEntityId']){
          this.onEntitySelected({"value":widget.widgetConfig.additionalConfig['linkEntityId']})
        }
        this.textGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          align: align,
          linkEntityId:widget.widgetConfig.additionalConfig['linkEntityId'],
          linkWidgetId:widget.widgetConfig.additionalConfig['linkWidgetId'] ?? [],
        });
        this.patchStyleProperties(this.textGroup, widget);
        break;

      case this.widgetTypes.navText:
        this.navTextGroup.reset({},{emitEvent: false});
        this.navTextGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
        },{onlySelf:true,emitEvent:false});
        break;

      case this.widgetTypes.separator:
        this.separatorGroup.reset({},{emitEvent: false});
        let borderWidth = (widget.widgetConfig.style as any)?.['size'] || '5px';
        this.separatorGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          thickness: borderWidth.slice(0, -2),
          marginTop: marginTop.slice(0, -2),
        });
        break;

      case this.widgetTypes.date:
        this.dataPickerGroup.reset({},{emitEvent: false});
        this.dataPickerGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          dateRangeEnable : additionalConfig?.dateRangeEnable,
          dateFormat : additionalConfig?.dateFormat,
          historicalDays : additionalConfig?.historicalDays,
          futureDays : additionalConfig?.futureDays

        });
        this.patchStyleProperties(this.dataPickerGroup, widget);
        break;
    
      case this.widgetTypes.geotag:
        this.geoGroup.reset({},{emitEvent: false});
        this.geoGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
        });
        this.patchStyleProperties(this.geoGroup, widget);
        break;

      case this.widgetTypes.geofence:
        this.geoFenceGroup.reset({},{emitEvent: false});
        this.geoFenceGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          geofenceTypes : additionalConfig?.geofenceTypes,
          geofenceShape : additionalConfig?.geofenceShape
        });
        this.patchStyleProperties(this.geoFenceGroup, widget);
        break;

      case this.widgetTypes.textbox:
        this.textFieldGroup.reset({},{emitEvent: false});
        this.textFieldGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          type: widget.widgetConfig.type,
          allowNegative:widget?.widgetConfig?.additionalConfig?.allowNegative,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          placeholder: widget.widgetConfig.placeholderText,
        },{onlySelf:true,emitEvent:false});
        this.patchStyleProperties(this.textFieldGroup, widget);
        break;

      case this.widgetTypes.address:
        this.addressGroup.reset({},{emitEvent: false});
        this.addressGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          textColor: textColor,
          type: widget.widgetConfig.type,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          placeholder: widget.widgetConfig.placeholderText,
        });
        this.patchStyleProperties(this.addressGroup, widget);
        break;

      case this.widgetTypes.dropdown:
        this.selectGroup.reset({},{emitEvent: false});
        this.selectGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          type: widget.widgetConfig?.type ?? 'SingleSelect',
          marginTop: marginTop.slice(0, -2),
          placeholder: widget.widgetConfig.placeholderText
            ? widget.widgetConfig.placeholderText
            : "select values",
        });
        this.dropdownDatasourceEntityForm.reset();
        this.patchStyleProperties(this.selectGroup, widget);
        break;

      case this.widgetTypes.imageUploader:
        this.imageUploaderGroup.reset({},{emitEvent: false});
        this.loading = true;
        this.getImageFile(widget);
        this.imageUploaderGroup.patchValue({
          key: widget.widgetKey,
          marginTop: marginTop.slice(0, -2),
        },{onlySelf:true,emitEvent:false});
        break;

      case this.widgetTypes.faceId:
        this.faceIdGroup.patchValue({
          key: widget.widgetKey,
          marginTop: marginTop.slice(0, -2),
        });
        break;

      case this.widgetTypes.fingerPrint:
        this.touchIdGroup.patchValue({
          key: widget.widgetKey,
          marginTop: marginTop.slice(0, -2),
        });
        break;

      case this.widgetTypes.searchableDropdown:
        this.selectGroup.reset({},{emitEvent: false});
        this.selectGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          type: widget.type,
          placeholder: widget.widgetConfig.placeholderText
            ? widget.widgetConfig.placeholderText
            : "select values",
        });
        this.patchStyleProperties(this.selectGroup, widget);
        break;

      case this.widgetTypes.filePicker:
        this.filePickerGroup.reset({},{emitEvent: false});
        this.filePickerGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          matUiType : widget.widgetConfig.matUiType,
          fileType : additionalConfig?.fileType,
          fileCompression : additionalConfig?.fileCompression ?? true,
          maxSize : additionalConfig?.maxSize,
          previewFile : additionalConfig?.previewFile,
        });
        this.patchStyleProperties(this.filePickerGroup, widget);
        break;

      case this.widgetTypes.image:
        this.imagePickerGroup.reset({},{emitEvent: false});
        this.imagePickerGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          matUiType: widget.widgetConfig.matUiType,
          uploadType: additionalConfig?.uploadType,
          allowedTypes: additionalConfig?.allowedTypes,
          maxSize:additionalConfig?.maxSize,
          Compression: additionalConfig?.Compression ?? true ,
          GalleryUpload:additionalConfig?.GalleryUpload ?? false,
          GeoReference:additionalConfig?.GeoReference ?? false,
          baringToggle:additionalConfig?.baringToggle ?? false,
          gpsAccuracy:additionalConfig?.gpsAccuracy ?? '',
          autoRotate: additionalConfig?.autoRotate,
        });
        this.patchStyleProperties(this.imagePickerGroup, widget);
        break;

      case this.widgetTypes.button:
        this.buttonGroup.reset({},{emitEvent: false});
        let btnTextColor='';
        let btnBgColor = '';
        if(!this.selectedWidgetMetaData.widgetConfig.customStyleApplied){
        if(widget.widgetConfig.matUiType == this.matUiTypes.outlined){
            btnBgColor = this.themeData.themeName.toLocaleLowerCase().includes('dark') ? '#c3c2d9' : '#87858e',
            btnTextColor = this.themeData.primaryColor,
            (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = btnTextColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = btnBgColor;
        }else if(widget.widgetConfig.matUiType == this.matUiTypes.filled){
            btnBgColor = this.themeData.primaryColor,
            btnTextColor = this.themeData.secondaryColor,
            (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = btnTextColor;
          (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = btnBgColor;
        }
      }else if(this.selectedWidgetMetaData.widgetConfig.customStyleApplied){
          btnBgColor = (widget.widgetConfig.style as any)?.['backgroundColor'] || '';
          btnTextColor = (widget.widgetConfig.style as any)?.['color'] || '';;
        }
        this.buttonGroup.patchValue({
          key: widget.widgetKey,
          textColor: btnTextColor,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
          bgColor: btnBgColor,
        });
        this.patchStyleProperties(this.buttonGroup, widget);
        break;

      case this.widgetTypes.printer:
        this.printerGroup.reset({},{emitEvent: false});
        this.printerGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          image: widget.widgetConfig.image == 'thermal-printer' ? 'Enter your code here!' :widget.widgetConfig.image,
          marginTop: marginTop.slice(0, -2),
          bgColor: bgColor,
        });
        break;

      case this.widgetTypes.chatView:
        this.chatViewgroup.reset({},{emitEvent: false});
        this.chatViewgroup.patchValue({
          key: widget.widgetKey,
          label: widget.widgetLabel,
          isLogo:widget.widgetConfig.additionalConfig.isLogo,
        });
        break;

      case this.widgetTypes.navButton:
       this.navButtonGroup.reset({},{emitEvent: false});
        this.navButtonGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          image: widget.widgetConfig?.image,
          connectedWorkerApplicationId: widget.widgetConfig?.additionalConfig.connectedWorkerApplicationId,
          connectedWorkerCustomerId: widget.widgetConfig?.additionalConfig?.connectedWorkerCustomerId ?? '',
        });
        let status = this.sharedService.getShowMenuStatus();
        this.showMenuGroup.patchValue({
          showMenu: status,
        });
        await this.getActualPage();
        if(widget.widgetConfig?.image === 'menu'){
          this.addMenuPanel();
        }
        break;

      case this.widgetTypes.singleselectcheckbox:
        this.checkBoxGroup.reset();
        this.checkBoxGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
        });
        this.patchStyleProperties(this.checkBoxGroup, widget);
        break;
        
      case this.widgetTypes.radio:
        this.radioButtonGroup.reset({},{emitEvent:false});
        this.radioButtonGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          title: widget.widgetLabel,
          marginTop: marginTop.slice(0, -2),
        },{onlySelf:true,emitEvent:false});
        this.patchStyleProperties(this.radioButtonGroup, widget);
        break;

      case this.widgetTypes.scanner:
        this.scannerGroup.reset({},{emitEvent: false});
        this.scannerGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          placeholder: widget.widgetConfig.placeholderText,
          marginTop: marginTop.slice(0, -2),
          textColor: textColor,
        });
        this.patchStyleProperties(this.scannerGroup, widget);
        break;

      case this.widgetTypes.datalist:
        this.dataListGroup.reset({},{emitEvent: false});
        const payload = {
          application_id: this.applicationId,
          entity_id: null,
          project_id: null,
          parent_entity_id: null
        }
        this.listOfEntitiesOfApplication = await this.getEntitiesOrAttributes(payload).toPromise();
        const dataListWidgetConfig = widget.widgetConfig?.dataListWidgetConfig;
        if (dataListWidgetConfig?.entityId) {
          payload.entity_id = dataListWidgetConfig.entityId
          const listOfPageWidgetsOfEntity = await this.getEntitiesOrAttributes(payload).toPromise();
          this.pageIdsOfAssociatedEntity = listOfPageWidgetsOfEntity?.page_ids ?? [];
          this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details);
          this.listOfWidgetsOfEntity.push({
            widgetId: "created_date",
            widgetLabel:"Created Date",
            widgetType:this.widgetTypes.date})
            this.lhsItems.clear();
            dataListWidgetConfig.lhsItems?.forEach((item: any) => {
            if (this.listOfWidgetsOfEntity.some((widget: any) => widget.widgetId === item.widgetId)) {
              this.lhsItems.push(this.patchField(item.widgetId));
            }
            });
            this.rhsItems.clear();
            dataListWidgetConfig.rhsItems?.forEach((item: any) => {
            if (this.listOfWidgetsOfEntity.some((widget: any) => widget.widgetId === item.widgetId)) {
              this.rhsItems.push(this.patchField(item.widgetId));
            }
            });

          const dataListWidgetConfigMap = new Map((dataListWidgetConfig.listOfWidgetsOfEntity || []).map((item: any) => [item.widgetId, item]));

          const formatedList = (this.listOfWidgetsOfEntity || []).map((item: any) => {
            const configItem = dataListWidgetConfigMap.get(item.widgetId);
            return configItem
              ? { show: (configItem as { show?: boolean }).show, ...item } : item;
          });

          this.listOfWidgetsOfEntity = formatedList
            // ? formatedList
            // : this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
        }
        this.filterWidgetList = this.updateFilterWidget(this.listOfWidgetsOfEntity);

        const dataListWidgetAdditionalConfig = widget.widgetConfig?.additionalConfig;
        if(dataListWidgetAdditionalConfig?.sort){
          if (Array.isArray(dataListWidgetAdditionalConfig?.defaultSortField)) {
            // Filter out any invalid sort fields from the array
            dataListWidgetAdditionalConfig.defaultSortField = dataListWidgetAdditionalConfig.defaultSortField.filter(
              (fieldId: string) => this.listOfWidgetsOfEntity.some((widget: any) => widget.widgetId === fieldId)
            );
            // If no valid fields remain, set default to created_date
            if (dataListWidgetAdditionalConfig.defaultSortField.length === 0) {
              dataListWidgetAdditionalConfig.defaultSortField = ['created_date'];
            }
          } else {
            // For single string value
            let widget = this.listOfWidgetsOfEntity.find((widget: any) => widget.widgetId === dataListWidgetAdditionalConfig?.defaultSortField);
            if (!widget) {
              dataListWidgetAdditionalConfig.defaultSortField = ['created_date'];
            }
          }

          if(dataListWidgetAdditionalConfig?.sortFields?.length > 0){
              let sortFieldsexisting = typeof dataListWidgetAdditionalConfig.sortFields === 'string'
                ? dataListWidgetAdditionalConfig.sortFields.split(',')
                : dataListWidgetAdditionalConfig.sortFields;
                const widgets = [...this.listOfWidgetsOfEntity];
                dataListWidgetAdditionalConfig.sortFields = sortFieldsexisting
                .reduce((fields: string[], widget: any) => {
                  const foundItem = widgets.find((item: any) => item.widgetId === widget);
                  if (foundItem) fields.push(foundItem.widgetId);
                  return fields;
                }, []);

                const sortConfig = this.dataListGroup.get('sortConfig') as FormArray;
                if (dataListWidgetAdditionalConfig.sortConfig && Array.isArray(dataListWidgetAdditionalConfig.sortConfig)) {
                  dataListWidgetAdditionalConfig.sortConfig.forEach((sortMapping: any) => {
                    // Filter out invalid appliesTo values that don't exist in listOfWidgetsOfEntity  
                    const validAppliesTo = sortMapping.appliesTo.filter((widgetId: string) => 
                      this.listOfWidgetsOfEntity.some((widget: any) => widget.widgetId === widgetId)
                    );

                    sortConfig.push(
                      this._formBuilder.group({
                        label: [sortMapping.label, Validators.required],
                        widgetId: [sortMapping.widgetId, Validators.required], 
                        appliesTo: [validAppliesTo, Validators.required]
                      })
                    );
                  });
                }
          }
        }
        this.dataListGroup.patchValue({
          key: widget.widgetKey,
          type: dataListWidgetConfig?.type ?? 'Card',
          entity: dataListWidgetConfig?.entityId,
          entryPageId: dataListWidgetConfig?.entryPageId,
          marginTop: [5],
          bold: false,
          italic: false,
          underline: false,
          fontSize: 0,
          mysubmission: dataListWidgetAdditionalConfig?.mysubmission,
          edit: dataListWidgetAdditionalConfig?.edit,
          search: dataListWidgetAdditionalConfig?.search,
          delete: dataListWidgetAdditionalConfig?.delete,
          download: dataListWidgetAdditionalConfig?.download,
          downloadType: dataListWidgetAdditionalConfig?.downloadType ?? 'submissions',
          sort: dataListWidgetAdditionalConfig?.sort ?? false,
          defaultSortType: dataListWidgetAdditionalConfig?.defaultSortType ?? 'desc',
          defaultSortField: dataListWidgetAdditionalConfig?.defaultSortField ?? ['created_date'],
          sortFields: typeof dataListWidgetAdditionalConfig?.sortFields === 'string' 
            ? dataListWidgetAdditionalConfig?.sortFields.split(',') 
            : dataListWidgetAdditionalConfig?.sortFields ?? [],
          widgets: dataListWidgetAdditionalConfig?.widgets ?? [],
          fileType: dataListWidgetAdditionalConfig?.fileType ?? [],
          filter: dataListWidgetAdditionalConfig?.filter,
          filterFormId: dataListWidgetAdditionalConfig?.filterFormId ?? '',
          groupBy: dataListWidgetAdditionalConfig?.groupBy
        });
        this.updateSelectAllToggleStatus();

        break;
        case this.widgetTypes.dataBoard:
          this.dataBoardGroup.reset({},{emitEvent: false});
          if(widget.widgetConfig.dataListWidgetConfig){
            widget.widgetConfig.dataListWidgetConfig.entityId && this.onEntitySelected({value: widget.widgetConfig.dataListWidgetConfig.entityId},true);
            widget.widgetConfig.apiResponce && this.fetchKeysFromAPI(widget.widgetConfig.apiResponce);
            let hasCustomLabels : boolean = widget.widgetConfig.dataListWidgetConfig?.lhsItemsCustomLabel?.length > 0 ? true : false
            this.dataBoardGroup.patchValue({label:widget.widgetLabel,dataSource:widget.widgetDataSource.datasource,...widget.widgetConfig.additionalConfig,...widget.widgetConfig.dataListWidgetConfig,customLabels:hasCustomLabels});
          }else{
            this.dataBoardGroup.patchValue({type:this.dataBoardTypes.display,headertype:this.databoardHeaderTypes.generic,serialNumber:false,label:widget.widgetLabel})
          }
          break;
        
      case this.widgetTypes.overviewTracker:
        this.overviewTrackerGroup.reset({},{emitEvent: false});
          if(widget.widgetConfig.overviewTrackerConfig){
            widget.widgetConfig.apiResponce && this.fetchKeysFromAPI(widget.widgetConfig.apiResponce);
            widget.widgetConfig.overviewTrackerConfig.entityId && this.onEntitySelected({value: widget.widgetConfig.overviewTrackerConfig.entityId},true)
            this.overviewTrackerGroup.patchValue({label:widget.widgetLabel,dataSource:widget.widgetDataSource.datasource,...widget.widgetConfig.additionalConfig,...widget.widgetConfig.overviewTrackerConfig});
          }else{
            this.overviewTrackerGroup.patchValue({legend:true,label:widget.widgetLabel});
          }
          break;

        case this.widgetTypes.barChart:
        case this.widgetTypes.stackBarChart:
        case this.widgetTypes.lineChart:
        case this.widgetTypes.pieChart:
        case this.widgetTypes.donutChart:
        case this.widgetTypes.fixedBarChart:
          this.chartDetailsFormGroup.reset({},{ emitEvent: false });
          this.apiDataSourceApiConfigForm.reset();

          this.individualSeriesProperties?.clear();
          this.yAxis1SeriesProperties?.clear();
          this.yAxis2SeriesProperties?.clear();
          this.listOfEntitiesOfMobAndWebApplication = await this.wformService.getMobAndWebEntities().toPromise();
          const chartDataSourceConfig = widget.widgetDataSource;
          let chartData = widget.widgetConfig.chartDataSourceData;
          let chartConfig = widget.widgetConfig.chartConfig;
          widget.widgetConfig.apiResponce && this.fetchKeysFromAPI(widget.widgetConfig.apiResponce);
          widget.widgetConfig?.chartConfig?.entity && this.onEntitySelected({value: widget.widgetConfig.chartConfig.entity},true)
          this.chartDetailsFormGroup.patchValue(chartConfig,{emitEvent: false, onlySelf: true});
          chartConfig?.yAxisProperties?.individualSeriesProperties?.forEach((prop: any) => {
            this.individualSeriesProperties.push(
              this._formBuilder.group({
                label: prop.label,
                key: prop.key,
                color: prop.color
              })
              )
            })
          chartConfig?.fixedChartYAxisProperties?.yAxis1SeriesProperties?.forEach((prop: any) => {
              this.yAxis1SeriesProperties.push(
                this._formBuilder.group({
                  label: prop.label,
                  key: prop.key,
                  color: prop.color
                })
                )
              })
            chartConfig?.fixedChartYAxisProperties?.yAxis2SeriesProperties?.forEach((prop: any) => {
                this.yAxis2SeriesProperties.push(
                  this._formBuilder.group({
                    label: prop.label,
                    key: prop.key,
                    color: prop.color
                  })
                  )
                })
            if (chartDataSourceConfig && chartConfig) {
              this.apiDataSourceApiConfigForm.patchValue(chartDataSourceConfig, {emitEvent: false, onlySelf: true});
              this.selectedApiGroup.patchValue({
                selectedApi: chartDataSourceConfig.datasource
              }, {emitEvent: false, onlySelf: true});
             chartData ? this.handleResponse(chartData) : this.getApiOrEntityDefinitionBasedOnForm('api',chartDataSourceConfig.dataSource );
            }
            else if (chartConfig?.entity) {
              chartData ? this.handleResponse(chartData) : this.getApiOrEntityDefinitionBasedOnForm('entity', chartDataSourceConfig.dataSource);
            }else{
              this.chartDetailsFormGroup.reset();  
            }
          break;
        case this.widgetTypes.chatBot:{
            this.chatBotConfigurationForm.reset({},{emitEvent: false});
            const additionalConfig = structuredClone(this.selectedWidgetMetaData.widgetConfig.additionalConfig);
            this.chatBotConfigurationForm.patchValue(additionalConfig);
          }
          break;
        case this.widgetTypes.filter:{
          this.filterGroup.reset({},{emitEvent: false});
            this.csWidgetsList = this.csWidgetsList.filter((widget:any) => this.displayWidgets.includes(widget.widgetType));
            this.wformService.fetchAdditionalFields();
          }
          break;
      default:
        console.warn("Unsupported widget type:", widget.widgetType);
        break;
    }
    
    if (widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'manual') {
      this.dataSourceTypeForm.patchValue({
        dataSourceType: 'Manual',
      })
      let dataValues = widget.widgetDataSource.datasource ?? [];
      if (dataValues.length > 0) {
        this.dataSourceValues = [];
        dataValues.forEach((obj: any) => {
          this.dataSourceValues.push(obj.label);
        })

      }
      else {
        this.dataSourceValues = [];
      }

     
    }else if(widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'entity' && widget.widgetType === this.widgetTypes.dropdown){
      this.dataSourceTypeForm.patchValue({
        dataSourceType: "Entity",
      })
      this.entitiesWidgetsMaping = [];
      this.onEntitySelected({value:widget.widgetDataSource?.datasource})
      this.dropdownBasedWidgetsArray.clear();
      this.dropdownDatasourceEntityForm.patchValue({
        entityId:widget.widgetDataSource?.datasource,
        widgetId: widget.widgetDataSource?.['response-parameter']?.label ?? '',
        widgetKey: widget.widgetDataSource?.['response-parameter']?.key ?? '',
        operator: widget.widgetDataSource['operator'] ?? '',
      })

      if(widget.widgetDataSource["basedWidgetIds"]){
        let filters = this.wformService.formatInToFiltersArray(widget.widgetDataSource["basedWidgetIds"]);
        this.dropdownDataSourceFilters.clear();
        filters.forEach(async (filter:any) => {
          if(filter.filterType === this.dropdownDataSourceFilterTypes.widget){
                await this.setEntityWidgetsMapping(filter['basedEntitys'] ?? [])
                let formGroup = this._formBuilder.group({
                  filterType: ['widget',Validators.required],
                  basedEntitys:[filter.basedEntitys,],
                  basedWidgetIds:this._formBuilder.array([])
                })
                let basedWidgetIdsArray:FormArray = formGroup.get('basedWidgetIds') as FormArray;
                this.patchDropDownDataSourceEntityMappings(filter['basedEntitys'],basedWidgetIdsArray,filter['basedWidgetIds'])
                filter["basedWidgetIds"].forEach((obj:any,index:number) => {    
                  this.addItemsInbasedWidgetControlMappingArray({value:obj["basedWidgets"]},index,basedWidgetIdsArray.at(index) ,obj['basedWidgetControlMapping'])
                })
                this.dropdownDataSourceFilters.push(formGroup);
                this.dropdownDataSourceFiltersMenu = [this.dropdownDataSourceFilterTypes.manual]
              }else if(filter.filterType === this.dropdownDataSourceFilterTypes.manual){
                  this.dropdownDataSourceFilters.push(
                    this._formBuilder.group({
                      filterType: 'manual',
                      ref: filter.ref,
                      dependentValue: filter.dependentValue,
                    })
                  );
      
              }
        })
      }
    }
    else if (widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'api' && widget.widgetType === this.widgetTypes.dropdown) {
      this.typeApi = true;
      this.dataSourceTypeForm.patchValue({
        dataSourceType: "API",
      })
      this.makeApiCall('event',widget.widgetDataSource?.apiId)
      this.apiForm.patchValue({
        apiUrl: widget.widgetDataSource?.datasource,
        method: widget.widgetDataSource?.method,
        payload: widget.widgetDataSource?.['request-parameter'],
        apiId:widget.widgetDataSource?.apiId,
        responseParameter: widget.widgetDataSource?.['response-parameter']?.label ? widget.widgetDataSource?.['response-parameter'].label : '',
        authApiUrl: widget.widgetDataSource.Authorization?.['auth-api-url'],
        auth: widget.widgetDataSource.Authorization?.['auth'],
        apiKey: widget.widgetDataSource.Authorization?.['api-key'],
      })
      let values = widget.widgetDataSource?.['request-parameter'];
      if (values.length > 0) {
        this.msFieldslist = [];
        values.forEach((key: any) => {
          this.formWidgets.forEach((field) => {
            if (field.widgetKey == key) {
              this.msFieldslist.push(field);

            }
          })

          this.msFieldslist.forEach((value) => {
            this.formWidgets = this.formWidgets.filter(
              (item: any) => item !== value
            );
          });
        })
      } else {
        this.msFieldslist = [];
      }

    }else if(widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'stage') {
      this.dataSourceTypeForm.patchValue({
        dataSourceType: "Stage",
      })
    } else {
      this.typeApi = false;
      this.apiForm.reset();
      this.dataSourceTypeForm.reset();
      this.msFieldslist = [];
    }
  }

  getColorValue(controlName: string) {
    let value = this.colorCtr.get(controlName)?.value || "#000000";
    this.sharedService.onSideNavListUpdateData({ 'value': value, 'type': 'input' })
    return value;
  }

  //#region  form section  widgets functionality

  addWidgetForForm() {
    let newInputWidget = { widgetId: 'forminput', key: '', name: 'New Input Field', type: 'text', widgetType: 'input', element: { label: "new field", showLabel: true, placeholderText: 'Enter Text', isRequired: false }, customStyleApplied: false, showDeleteButton: false, style: {} }

    const indexOfTypeButton = this.selectedSectionData.widgets.findIndex(widget => widget.widgetType === 'button');


    if (indexOfTypeButton === -1) {
      this.selectedSectionData.widgets.push(newInputWidget);
    } else {
      this.selectedSectionData.widgets.splice(indexOfTypeButton, 0, newInputWidget);
    }
  }

  setWidgetIndexAndPatchValues(index: number) {
    let widgetData: WIDGET;
    if (index >= 0 && index < this.selectedSectionData.widgets.length) {
      widgetData = this.selectedSectionData.widgets[index];
      if (widgetData.widgetType === 'input') {
        this.sectionWidgetGroup.reset();
        let textColor = (widgetData.style as any)['color'];
        let placeholder;
        let label;
        if (widgetData.element) {
          label = widgetData.element.label;
          placeholder = widgetData.element.placeholderText;
        }
        this.sectionWidgetGroup.patchValue({
          key: widgetData.key,
          textColor: textColor,
          type: widgetData.type,
          label: label,
          placeholder: placeholder
        });
      }
      else {
        this.FormbuttonGroup.reset();
        let textColor = (widgetData.style as any)['color'];
        let bgColor = (widgetData.style as any)['backgroundColor'];
        let width = (widgetData.style as any)['width'];
        let label;
        if (widgetData.element) {
          label = widgetData.element.label;
        }
        this.FormbuttonGroup.patchValue({
          key: widgetData.key,
          textColor: textColor,
          width: width,
          label: label,
          bgColor: bgColor
        });
        this.openedWidgetForm = index;
      }
    } else {
      console.error('Invalid index');
    }
  }

  //#endregion


  //#region menu panel

  private initializeMenuPanelForm(): void {
    this.itemForm = this._formBuilder.group({
      itemArray: this._formBuilder.array([]),
    });

    const itemArray = this.itemForm.get('itemArray') as FormArray;

    this.pagesList.forEach((item) => {
      itemArray.push(
        this._formBuilder.group({
          name: item.pageName,
          pageId: item.pageId,
          isChecked: false,
        })
      );
    });


  }

  get itemControls(): FormGroup[] {
    return (this.itemForm.get('itemArray') as FormArray).controls as FormGroup[];
  }

  toggleWidgetStatus(widget: any, index: any, event: any): void {
    if (!this.checkActualMenu) {
      this.menupaneldetails.widgets[index].widgetConfig['enable'] = event.checked;
      this.selectedPageData.forms.forEach((form: any) => {
        if (form.formConfig.formType == 'menuPanel') {
          form = this.menupaneldetails
        }
      })
      this.sharedService.setSelectedPage(this.selectedPageData);
    }
    else {

      if(event.checked && !widget.widgetConfig['storedType']){
        let linkedPage :any = {};
        this.pagesList.some((page) => {
          if(page.pageName === widget.widgetLabel){
            linkedPage = page;
            return true;
          }
          return false;
        })
        const newObject: any = {action: linkedPage.pageId,};
        newObject[widget.widgetKey] = ["default"];

        widget.widgetConfig.actions = [{
          "action_type": "navigation",
          "conditional_clause": [newObject]
        }];
      }else if(!event.checked && !widget.widgetConfig['storedType']){
        widget.widgetConfig.actions = [];
      }
      widget.widgetConfig['enable'] = event.checked
      let widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': widget.widgetId,
      }
      this.sharedService.updateWidget(widgetPostData, widget.widgetId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      })
      this.menupaneldetails.widgets[index].widgetConfig['enable'] = event.checked;
      this.selectedPageData.forms.forEach((form: any) => {
        if (form.formConfig.formType == 'menuPanel') {
          form = this.menupaneldetails
        }
      })
      this.sharedService.setSelectedPage(this.selectedPageData);
    }

  }

  checkMenuExists(){
    this.actualpageDetails.forms.forEach((form: any) => {
      if (form.formConfig.formType == "menuPanel") {
        this.checkActualMenu = true;
      }
    })
  }

  addMenuPanel() {
    this.checkMenuExists();
    if (!this.checkActualMenu) {

      let menupanelObj = {
        "formLabel": "menu panel",
        "formKey": "xz1-manuPanel3",
        "formVersion": 2,
        "entityKey": "",
        "parentEntityKey": "",
        "formConfig": {
          "style": {},
          "actions": {},
          "formType": "menuPanel",
          "formsWidgets": [],
          "customStyleApplied": false
        },
        "is_published": false,
        "widgets": []
      }
  
      if (this.selectedPageData && this.selectedPageData.pageName) {
        menupanelObj.formKey = new Date(). getTime().toString()+ this.selectedPageData.pageName;
      }

      let textwidgets: any = [];
      let index = 0;
      let pages = [...this.pagesList];
      pages.push({
        "pageId": "",
        "pageName": "Peripherals",
        "pageType":this.pageTypes.peripherals,
        "open": false
      });
      pages.push({
        "pageId": "",
        "pageName": "Change Password",
        "pageType":this.pageTypes.changePassword,
        "open": false
      });
      pages.push({
        "pageId": "",
        "pageName": "Logout",
        "pageType":this.pageTypes.logout,
        "open": false
      })
      pages.forEach((page) => {
        let textwidget:any = {
          widgetLabel: "Text",
          widgetKey: "",
          widgetType: "text",
          widgetConfig: {
            style: {},
            enable: false,
            actions: [
              {
            
              },
            ],
            element: {},
            additionalConfig: {},
            showDeletebutton: true,
            customStyleApplied: false,
          },
          "widgetDataSource": {},
        }
        if (page.pageType == this.pageTypes.changePassword || page.pageType == this.pageTypes.logout) {
          index++;
          textwidget.widgetLabel = page.pageName;
          textwidget.widgetKey =  new Date(). getTime().toString()+  page.pageName.slice(0, 2) + index;
          textwidget.widgetConfig['storedType'] = "Default";
          textwidgets.push(textwidget);
        }
        else if (![this.pageTypes.loginPage, this.pageTypes.splashScreen,this.pageTypes.previewPage,this.pageTypes.dataListView].includes(page.pageType)) {
          index++;
          textwidget.widgetLabel = page.pageName;
          textwidget.widgetKey = new Date(). getTime().toString() +  page.pageName.slice(0, 2) + index;
            const newObject: any = {
              action: page.pageId,
            };
          newObject[textwidget.widgetKey] = ["default"];
          textwidget.widgetConfig.actions = [
            {
              action_type: "navigation",
              conditional_clause: [newObject],
            },
          ];
          textwidgets.push(textwidget);
        }
      });

      menupanelObj.widgets = textwidgets;
      this.selectedComponents.push(menupanelObj);
      this.menupaneldetails = menupanelObj;
      this.menupaneldetails.widgets = this.menupaneldetails.widgets.filter((widget:any) => {
        return widget.widgetLabel !== this.pageName;
      });
      this.selectedPageData.forms = this.selectedComponents;
      this.sharedService.setSelectedPage(this.selectedPageData);
    } else if(this.checkActualMenu){
          let pageNames:string[] = []
          let checkMissingPage:boolean = false;
           pageNames = this.pagesList.map( (page: any) => page.pageName)
           pageNames = pageNames.concat("Peripherals","Change Password","Logout");
           let widgetNames:string[] = []
          this.menupaneldetails.widgets.forEach((widget:any,index:number) => {
           if(!pageNames.includes(widget.widgetLabel)){
            checkMissingPage = false;
            this.menupaneldetails.formConfig.formsWidgets.splice(index,1);
            this.menupaneldetails.widgets.splice(index,1);
           }else{
            widgetNames.push(widget.widgetLabel);
           }
          })
          let textWidgets:any[] = [];
          pageNames.forEach((pageName,index:number) => {
            if(!widgetNames.includes(pageName) && pageName !== this.pageName){
              let textwidget = {
                widgetLabel: "Text",
                widgetKey: "",
                widgetType: "text",
                masterWidgetId:'ae913c6e-837e-11ee-b962-0242ac120002',
                widgetConfig: {
                  style: {},
                  enable: false,
                  actions: [{},],
                  element: {},
                  additionalConfig: {},
                  showDeletebutton: true,
                  customStyleApplied: false,
                },
                widgetDataSource: {},
              };
              if(this.pagesList[index] ){
              if (this.pagesList[index].pageType == this.pageTypes.changePassword || this.pagesList[index].pageType == this.pageTypes.logout) {
                textwidget.widgetLabel = this.pagesList[index].pageName;
                textwidget.widgetKey = new Date(). getTime().toString() + pageName;
                textWidgets.push(textwidget);
              } else if (![this.pageTypes.loginPage, this.pageTypes.splashScreen,this.pageTypes.previewPage,this.pageTypes.dataListView].includes(this.pagesList[index].pageType)) {
                textwidget.widgetLabel = this.pagesList[index].pageName;
                textwidget.widgetKey = new Date(). getTime().toString() + pageName;
                const newObject: any = {
                  action: this.pagesList[index].pageId,
                };
                newObject[textwidget.widgetKey] = ["default"];
                textwidget.widgetConfig.actions = [{
                    action_type: "navigation",
                    conditional_clause: [newObject],
                  },
                ];
                textWidgets.push(textwidget);
              }
            }
          }
        })
          if(textWidgets.length > 0){
            this.sharedService.addMultipleWidgets(textWidgets,this.menupaneldetails.formId,this.applicationId,this.menupaneldetails).pipe(takeUntil(this.destroy$)).subscribe((data)=>{
              this.sharedService.getPageById(this.selectedPageData.pageId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
                this.sharedService.setSelectedPage(data);
              })
            })
          }else if(checkMissingPage){
            let formPostData = {
                applicationId : this.applicationId,
                formId: this.menupaneldetails.formId,
                formsWidgets: [...this.menupaneldetails.formConfig.formsWidgets],
              }  
            this.sharedService.updateForm(formPostData,this.menupaneldetails.formId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
    
            })
          }
    }
  }

  async menePanelAdderApical() {
    if (this.selectedWidgetMetaData.widgetConfig.image === "arrow_back") {
      this.sharedService.deleteForm(this.menupaneldetails.formId, this.selectedPageData).pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.sharedService.getPageById(this.selectedPageData.pageId.pipe(takeUntil(this.destroy$))).subscribe((data: any) => {
          this.sharedService.setSelectedPage(data);
        })
      });
    }
    else if (this.selectedWidgetMetaData.widgetConfig.image === "menu") {
      try {
        if (!this.checkActualMenu) {
          let menupanelSection = {
            key: '',
            sectionId: 'section1',
            name: "menu panel",
            image: 'form',
            sectionType: "menuPanel",
            showDeleteButton: false,
            style: {},
            widgets: [],
            isEditable: false,
          }
          let sectionWidgets: any = [];
          this.menupaneldetails.widgets.forEach((widget: any) => {
            let sectionWidget : any= { widgetId: 'heading1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120002", key: '', name: "Text", widgetType: this.widgetTypes.plainText, values: 'Text', showDeleteButton: true, customStyleApplied: false, image: "rich_text", style: {}, actions: [],enable:false }
            sectionWidget.name = widget.widgetLabel;
            sectionWidget.key = widget.widgetKey;
            sectionWidget.enable = widget.widgetConfig['enable'];
            sectionWidget.actions = widget.widgetConfig.actions;
            if(widget.widgetConfig['storedType']){
              sectionWidget['storedType'] = "default";
            }
            sectionWidgets.push(sectionWidget);
          })
          menupanelSection.key = this.menupaneldetails.formKey;
          menupanelSection.name = this.menupaneldetails.formLabel;
          menupanelSection.widgets = sectionWidgets;
          this.sharedService.addSection(this.selectedPageData.pageId, menupanelSection, this.actualpageDetails).pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
            this.getPageById(this.page?.pageId as string).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
              this.sharedService.setSelectedPage(data);
            })
          })
        }
      } catch (error) {
        console.error('Error fetching page details:', error);
      }
    }
  }
  //#endregion

//#region widget data update
  getPageById(pageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = { page_id: pageId }
    return this.httpService.placeAPICall(apiConfig);
  }

  updateWidgetName(event: any) {
    this.selectedWidgetMetaData.name = event.target.value;
    if (this.page.pageId)
      this.sharedService.setWidgetLabel(this.selectedWidgetMetaData.name, this.widgetId);
  }

  updateWidgetText(event: any) {
    this.selectedWidgetMetaData.values = event.target.value;
    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, this.selectedWidgetMetaData);
  }

  removeWidget(widgetIdex: number) {
    if (this.page.pageId)
      this.sharedService.removeWidget(this.page.pageId, this.sectionIndex, widgetIdex);
  }

  onWidgetColorChange(event: any) {
    this.selectedWidgetMetaData.customStyleApplied = true;
    (this.selectedWidgetMetaData.style )["color"] = event?.target?.value;
    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, this.selectedWidgetMetaData);
  }

  deleteRadioOption(index: any) {
    if (this.selectedWidgetMetaData?.widgetDataSource?.datasource) {
      this.selectedWidgetMetaData.widgetDataSource.datasource.splice(index, 1);
      this.showRadioValueError = '';
      this.showRadioErrorMessage[index] = false;
      this.isLabelEmpty = false;
    }
  }
  
  AddRadioOption() {
    const datasource = this.selectedWidgetMetaData?.widgetDataSource?.datasource;
    if (datasource && !datasource.some((item: any) => item.label === "") && this.hasUniqueLabels(datasource)) {
      this.showRadioValueError = '';
      this.selectedWidgetMetaData.widgetDataSource.datasource.push({ key: "", label: "" });
    } else {
      if(!this.hasUniqueLabels(datasource)){
      this.showRadioValueError = "Please remove dublicate values";
      }else{
        datasource.forEach((item:any,index:number) => {
          item.label == '' ? this.showRadioErrorMessage[index] = true :  this.showRadioErrorMessage[index] = false;
        })
        this.showRadioValueError = "";
      }
    }
    this.isLabelEmpty = false
  }

  hasUniqueLabels(list:any): boolean {
    const uniqueNames = new Set<string>();
    for (const obj of list) {
      if (uniqueNames.has(obj.label)) {
        return false; 
      }
      uniqueNames.add(obj.label);
    }
    return true;
  }
  
  updateRadioValue(event: any, itemIndex: number, value: any) {
    event.target.value == '' ? this.showRadioErrorMessage[itemIndex] = true :  this.showRadioErrorMessage[itemIndex] = false;
    let newValue = value;
    value.label = event.target.value;
    this.selectedWidgetMetaData.widgetDataSource.datasource[itemIndex] = newValue;
    this.showRadioValueError = ""
    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, this.selectedWidgetMetaData);
  }

  updateWidgetData(form: FormGroup, data: any) {
    this.selectedWidgetMetaData.widgetKey = data.key;
    if(this.selectedWidgetMetaData.widgetConfig && data.connectedWorkerApplicationId) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.connectedWorkerApplicationId = data.connectedWorkerApplicationId;
    }
    if(this.selectedWidgetMetaData.widgetConfig && data.connectedWorkerCustomerId) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.connectedWorkerCustomerId = data.connectedWorkerCustomerId;
    }
    if (this.selectedWidgetMetaData.widgetConfig && data?.placeholder) {
      this.selectedWidgetMetaData.widgetConfig.placeholderText = data?.placeholder;
    }
    if (data.label || data.label == '') {
      this.selectedWidgetMetaData.widgetLabel = data.label
    }
    if (data.title || data.title == '') {
      this.selectedWidgetMetaData.widgetLabel = data.title
    }
    if (this.widgetTypes.textbox === this.selectedWidgetMetaData.widgetType) {
      this.selectedWidgetMetaData.widgetConfig['additionalConfig']['allowNegative'] = 
        form.value?.type === 'number' ? form.value.allowNegative : false;
    }

    const selectedWidgetMetaData = this.selectedWidgetMetaData;
    if (selectedWidgetMetaData?.style) {
      selectedWidgetMetaData.style.color = data.textColor;
    }
    if (data?.textColor !== this.selectedWidgetMetaData.widgetConfig.style.color) {
      this.selectedWidgetMetaData.widgetConfig.customStyleApplied = true;
      (this.selectedWidgetMetaData.widgetConfig?.style )["color"] = data.textColor;
    }
    let widgetType = this.selectedWidgetMetaData.widgetType;
    let excludedTypes = [this.widgetTypes.navButton, this.widgetTypes.separator, this.widgetTypes.fingerPrint, this.widgetTypes.faceId];

    if (!excludedTypes.includes(widgetType)) {
      data?.bold ? (this.selectedWidgetMetaData.widgetConfig?.style )["font-weight"] = "bold" : (this.selectedWidgetMetaData.widgetConfig?.style)["font-weight"] = 'normal'
      data?.italic ? (this.selectedWidgetMetaData.widgetConfig?.style )["font-style"] = "italic" : (this.selectedWidgetMetaData.widgetConfig?.style )["font-style"] = 'normal'
      data?.underline ? (this.selectedWidgetMetaData.widgetConfig?.style )["text-decoration"] = "underline" : (this.selectedWidgetMetaData.widgetConfig?.style )["text-decoration"] = 'none'
      data?.fontSize > 0 ? (this.selectedWidgetMetaData.widgetConfig?.style )["font-size"] = data?.fontSize + 'px' : (this.selectedWidgetMetaData.widgetConfig?.style )["font-size"] = '16px'
    }

    if (data?.textColor !== this.selectedWidgetMetaData.widgetConfig.style.color) {
      this.selectedWidgetMetaData.widgetConfig.customStyleApplied = true;
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = data.textColor;
    }

    if (data?.bgColor !== this.selectedWidgetMetaData.widgetConfig.style.backgroundColor) {
      this.selectedWidgetMetaData.widgetConfig.customStyleApplied = true;
      (this.selectedWidgetMetaData.widgetConfig?.style )["backgroundColor"] = data.bgColor;
    }
    if (data?.matUiType) {
      this.selectedWidgetMetaData.widgetConfig['matUiType'] = data.matUiType;
    }
    if (data?.height) {
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["height"] = data.height + "%";
    }
    if (data?.align) {

      (this.selectedWidgetMetaData.widgetConfig?.style )["text-align"] = data.align;
    }
    if (data?.thickness) {
      (this.selectedWidgetMetaData.widgetConfig?.style )["size"] = data.thickness + "px";
    }
    if (data?.marginTop) {
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["margin-top"] = data.marginTop + "px";
    }

    if(data?.isLogo){
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.isLogo = data.isLogo;
    }

    if(data?.image){
      this.selectedWidgetMetaData.widgetConfig.image = data?.image;
      this.selectedWidgetMetaData.widgetType === this.widgetTypes.navButton && data.image == " " ? this.selectedWidgetMetaData.widgetConfig.type = this.iconTpes.noIcon : this.selectedWidgetMetaData.widgetConfig.type = this.iconTpes[data?.image];
    }

    if (this.selectedWidgetMetaData.widgetConfig && data?.type) {
      this.selectedWidgetMetaData.widgetConfig.type = data?.type;
    }
    if (data.value1label && this.selectedWidgetMetaData.widgetConfig.additionalConfig.values) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.values[0] = data.value1label
    }
    if (data.value1label && this.selectedWidgetMetaData.widgetConfig.additionalConfig.values) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.values[1] = data.value2label
    }

    if (this.widgetTypes.plainText === this.selectedWidgetMetaData?.widgetType) {
      if (!this.selectedWidgetMetaData.widgetConfig.additionalConfig) {
        this.selectedWidgetMetaData.widgetConfig.additionalConfig = {};
      }
        this.selectedWidgetMetaData.widgetConfig.additionalConfig['linkEntityId'] = data.linkEntityId ?? '';    
        this.selectedWidgetMetaData.widgetConfig.additionalConfig['linkWidgetId'] = data.linkWidgetId ?? [];
    }
    
    
    // date range picker
    if (this.selectedWidgetMetaData.widgetConfig && this.selectedWidgetMetaData.widgetType === this.widgetTypes.date) {
      const additionalConfig = this.selectedWidgetMetaData.widgetConfig.additionalConfig ?? {};
      additionalConfig.dateRangeEnable = data?.dateRangeEnable ?? additionalConfig.dateRangeEnable;
      additionalConfig.dateFormat = data?.dateFormat ?? additionalConfig.dateFormat;
      additionalConfig.historicalDays = data?.historicalDays ?? additionalConfig.historicalDays;
      additionalConfig.futureDays = data?.futureDays ?? additionalConfig.futureDays;
      additionalConfig.fileType = data?.fileType ?? additionalConfig.fileType;
      additionalConfig.maxSize = data?.maxSize ?? additionalConfig.maxSize;
      additionalConfig.previewFile = data?.previewFile ?? additionalConfig.previewFile;
      additionalConfig.fileCompression = data?.fileCompression ?? additionalConfig.fileCompression;
      additionalConfig.geofenceTypes = data?.geofenceTypes ?? additionalConfig.geofenceTypes
      additionalConfig.geofenceShape = data?.geofenceShape ?? additionalConfig.geofenceShape

      this.selectedWidgetMetaData.widgetConfig.additionalConfig = additionalConfig;
      additionalConfig.uploadType = data?.uploadType ?? additionalConfig.uploadType;
    }
    if(this.selectedWidgetMetaData.widgetType === this.widgetTypes.filePicker){
      const additionalConfig = this.selectedWidgetMetaData.widgetConfig.additionalConfig ?? {};
     additionalConfig.fileType = data?.fileType ?? additionalConfig.fileType;
     additionalConfig.maxSize = data?.maxSize ?? additionalConfig.maxSize;
     additionalConfig.previewFile = data?.previewFile ?? additionalConfig.previewFile;
      additionalConfig.fileCompression = data?.fileCompression ?? additionalConfig.fileCompression;
    }

    if(this.selectedWidgetMetaData.widgetConfig && this.selectedWidgetMetaData.widgetType === this.widgetTypes.chatBot) {
      const uploadedAvatar = this.selectedWidgetMetaData.widgetConfig?.additionalConfig?.uploadedAvatar ?? '';
      this.selectedWidgetMetaData.widgetConfig.additionalConfig = data;
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.uploadedAvatar = uploadedAvatar;
    }
    // image Picker widget
    const { uploadType } = data;
    const configMapping = {
      image: IMGVIDPICKER_CONSTANTS.IMAGE,
      video: IMGVIDPICKER_CONSTANTS.VIDEO
    };
    if(this.selectedWidgetMetaData.widgetConfig && (data?.allowedTypes) )
    {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig = {};
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.uploadType = data?.uploadType ??  this.selectedWidgetMetaData.widgetConfig.additionalConfig.uploadType;
      const selectedConfig = configMapping[uploadType as 'image' | 'video'];
      if (selectedConfig) {
        selectedConfig.CONFIGS.forEach((configKey: string | number) => {
          if (!isNullOrUndefined(data[configKey])) {
            this.selectedWidgetMetaData.widgetConfig.additionalConfig[configKey] = data[configKey];
          }
        });
      }
    }

    if (this.page.pageId){
      let widget;
      widget = structuredClone(this.selectedWidgetMetaData);
      if(widget.widgetConfig['apiResponce']){
        delete widget.widgetConfig.apiResponce;
      }
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, widget);
    }
  }

  get combinedItems(): any[] {
    const currentKey = JSON.stringify({
      lhs: this.lhsItems?.value,
      rhs: this.rhsItems?.value
    });
  
    if (this.rhslhslastInputs !== currentKey) {
      this.rhslhslastInputs = currentKey;
      this.cachedCombinedItems = this.computeCombinedItems();
    }
  
    return this.cachedCombinedItems;
  }
  
  private computeCombinedItems(): any[] {
    const lhsItemsValues = this.lhsItems?.value || [];
    const rhsItemsValues = this.rhsItems?.value || [];
  
    const createdDateItem = {
      widgetId: "created_date",
      widgetLabel: "Created Date",
      widgetType: this.widgetTypes.date
    };
  
    const allItems = [
      ...lhsItemsValues,
      ...rhsItemsValues,
    ];
  
    if (!allItems.some((item: any) => item.widgetId === "created_date")) {
      allItems.push(createdDateItem);
    }
  
    return allItems.map(item =>
      this.listOfWidgetsOfEntity.find((widget: any) => widget.widgetId === item.widgetId) || item
    );
  }

  updateWidgetValues(formGroup?:FormGroup) {
    if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.navButton) {
      this.menePanelAdderApical();
    }
    let widgetPostData = {};
    let tempFlag = false;
    let widget = JSON.parse(JSON.stringify(this.selectedWidgetMetaData))
    if(widget.widgetConfig['apiResponce']){
      delete widget.widgetConfig.apiResponce;
    }
    if(!widget.widgetConfig.customStyleApplied){
      delete widget.widgetConfig.style.backgroundColor;
      delete widget.widgetConfig.style.color;
    }
    if (widget.widgetType === this.widgetTypes.radio) {
      tempFlag = true;
      widget.widgetDataSource.datasource.forEach((item: any) => {
        if (item.label == "") {
          this.isLabelEmpty = true
          tempFlag = false;
          return;
        }
      })
      const dataSourceToCheck:any[] = []
      widget.widgetDataSource?.datasource?.map((x:any) => {
        dataSourceToCheck.push(x?.label)
      })
      const hasDuplicates = (array: any[]): boolean => {
        const set = new Set<any>();
        for (const item of array) {
            if (set.has(item)) {
                return true;
            }
            set.add(item);
        }
        return false;
      }
     const duplicatesExist = hasDuplicates(dataSourceToCheck);
     if(duplicatesExist){
      this.toasterService.error("Duplicate Label Exits")
      return;
     }
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetDataSource': widget.widgetDataSource,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }

    }else if(widget.widgetType === this.widgetTypes.image) {
      if(this.imagePickerGroup.get('uploadType')?.value == 'document') {
        widget.widgetConfig.additionalConfig.uploadType = this.imagePickerGroup.get('uploadType')?.value;
      }
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    } else if(widget.widgetType === this.widgetTypes.datalist) {
      widget.widgetConfig.additionalConfig.mysubmission = this.dataListGroup.get('mysubmission')?.value;
      widget.widgetConfig.additionalConfig.edit = this.dataListGroup.get('edit')?.value;
      widget.widgetConfig.additionalConfig.search = this.dataListGroup.get('search')?.value;
      widget.widgetConfig.additionalConfig.filter = this.dataListGroup.get('filter')?.value;
      widget.widgetConfig.additionalConfig.filterFormId = this.dataListGroup.get('filterFormId')?.value;
      widget.widgetConfig.additionalConfig.download = this.dataListGroup.get('download')?.value;
      widget.widgetConfig.additionalConfig.sort = this.dataListGroup.get('sort')?.value;
      widget.widgetConfig.additionalConfig.defaultSortType = this.dataListGroup.get('defaultSortType')?.value;
      widget.widgetConfig.additionalConfig.defaultSortField = this.dataListGroup.get('defaultSortField')?.value;
      const downloadType = this.dataListGroup.get('downloadType')?.value;
      const downloadValue = this.dataListGroup.get('download')?.value;
      if (downloadValue) {
        widget.widgetConfig.additionalConfig.downloadType = downloadType;
        
        if (downloadType === 'submissions') {
          widget.widgetConfig.additionalConfig.widgets = this.dataListGroup.get('widgets')?.value;
          widget.widgetConfig.additionalConfig.fileType = this.dataListGroup.get('fileType')?.value;
        }
      }
      if(widget.widgetConfig.additionalConfig.sort){
        widget.widgetConfig.additionalConfig.sortFields = this.dataListGroup.get('sortFields')?.value?.join(',');
        // Main sortFields update
        const existingLabels: string[] = [];
        const updatedSortConfig = this.sortFieldsMapping.value.map((mapping:any) => {
          const uniqueLabel = this.getUniqueLabel(mapping.label, existingLabels);
          existingLabels.push(uniqueLabel);
          return {
            ...mapping,
            label: uniqueLabel
          };
        });

        widget.widgetConfig.additionalConfig.sortConfig = updatedSortConfig;

        // Update the form array to reflect changes in UI
        const sortConfigArray = this.dataListGroup.get('sortConfig') as FormArray;
        sortConfigArray.clear(); // Clear existing controls

        updatedSortConfig.forEach((config: any) => {
          sortConfigArray.push(
            this._formBuilder.group({
              widgetId: [config.widgetId, Validators.required],
              label: [config.label, Validators.required], 
              appliesTo: [config.appliesTo, Validators.required]
            })
          );
        });

      }
      widget.widgetConfig.additionalConfig.delete = this.dataListGroup.get('delete')?.value;
      widget.widgetConfig.additionalConfig.groupBy = this.dataListGroup.get('groupBy')?.value;
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    } else if(widget.widgetType === this.widgetTypes.dataBoard) {
      delete widget.widgetConfig['apiResponse'];
      widget.widgetConfig.additionalConfig['serialNumber'] = this.dataBoardGroup.get('serialNumber')?.value;
      widget.widgetConfig.additionalConfig['download'] = this.dataBoardGroup.get('download')?.value;
      const downloadType = this.dataBoardGroup.get('downloadType')?.value;
      const downloadValue = this.dataBoardGroup.get('download')?.value;
      if (downloadValue) {
        widget.widgetConfig.additionalConfig.downloadType = downloadType;
        if (downloadType === 'submissions') {
          widget.widgetConfig.additionalConfig.widgets = this.dataBoardGroup.get('widgets')?.value;
          widget.widgetConfig.additionalConfig.fileType = this.dataBoardGroup.get('fileType')?.value;
        }
      }
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetDataSource':widget.widgetDataSource,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
      if(formGroup && formGroup.invalid){
          tempFlag = false;
      }
    }else if(widget.widgetType === this.widgetTypes.overviewTracker) {
      delete widget.widgetConfig['apiResponse'];
      delete widget.widgetConfig.additionalConfig?.statusesColorObj;
      widget.widgetConfig.additionalConfig['serialNumber'] = this.overviewTrackerGroup.get('serialNumber')?.value;
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetDataSource':widget.widgetDataSource,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    }
    else if(widget.widgetType === this.widgetTypes.filter){
      if( widget.widgetConfig?.filters?.length > 0){
        widget.widgetConfig.filters.forEach((filterConfig:any) => {
           filterConfig["basedOn"] = this.filterGroupBasedOnFormatter(filterConfig?.basedOn,"string") ?? ""
        })
      }

      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    }else if(widget.widgetType === this.widgetTypes.imageUploader) {
      if(widget.widgetConfig.additionalConfig?.image ) {
        delete widget.widgetConfig.additionalConfig.image;
      }
       widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;

    }
    else {
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'widgetLabel': widget.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    }
    if (tempFlag) {
      this.showRadioValueError = "";
      this.sharedService.updateWidget(widgetPostData, this.selectedWidgetMetaData.widgetId).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      })
    }
  }

   // Helper function to check and modify duplicate labels
   getUniqueLabel(label: string, existingLabels: string[]): string {
    let uniqueLabel = label;
    let counter = 1;
    
    while (existingLabels.includes(uniqueLabel)) {
      uniqueLabel = `${label}(${counter})`;
      counter++;
    }
    
    return uniqueLabel;
  }

  updateShowMenuStatus(data: any) {
    this.sharedService.setShowMenuStatus(data.showMenu);
  }

  updateSectionData(data: any) {
    this.selectedSectionData.name = data.label;
    this.selectedSectionData.key = data.key;
    (this.selectedSectionData.style as any)["backgroundColor"] = data.bgColor;
    if (this.page.pageId)
      this.sharedService.updateSection(this.page.pageId, this.selectedSectionData);
  }

  getWidgetColorValue(): string {
    return (this.selectedWidgetMetaData.style as any)["color"];
  }

  changeSubscribe() {

    this.textGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(),takeUntil(this.destroy$))
      .subscribe((formValue) => {
        if (
          this.selectedWidgetMetaData.widgetType === this.widgetTypes.plainText
        ) {
          this.updateWidgetData(this.textGroup, formValue);
        }
      });

    this.navTextGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(),takeUntil(this.destroy$))
      .subscribe((formValue) => {
        if (
          this.selectedWidgetMetaData.widgetType == this.widgetTypes.navText
        ) {
          this.updateWidgetData(this.navTextGroup, formValue);
        }
      });

    this.textFieldGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.textbox) {
          this.updateWidgetData(this.textFieldGroup, formValue);
        }
      });

    this.addressGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.address) {
          this.updateWidgetData(this.addressGroup, formValue);
        }
      });

    this.selectGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.dropdown || this.selectedWidgetMetaData.widgetType === this.widgetTypes.searchableDropdown) {
          this.updateWidgetData(this.selectGroup, formValue);
        }
      });

    this.filePickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.filePicker) {
          this.updateWidgetData(this.filePickerGroup, formValue);
        }
      });

    this.imagePickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.image) {
          this.updateWidgetData(this.imagePickerGroup, formValue);
        }
      });

    this.buttonGroup.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.button) {
          this.updateWidgetData(this.buttonGroup, formValue);
        }
      });

    this.printerGroup.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.printer) {
          this.updateWidgetData(this.printerGroup, formValue);
        }
      });

    this.chatViewgroup.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.chatView) {
          this.updateWidgetData(this.chatViewgroup, formValue);
        }
      });

    this.navButtonGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.navButton) {
          this.updateWidgetData(this.buttonGroup, formValue);
        }
      });

    this.showMenuGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        this.updateShowMenuStatus(formValue);
      });

    this.checkBoxGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.singleselectcheckbox) {
          this.updateWidgetData(this.checkBoxGroup, formValue);
        }
      });

    this.radioButtonGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      skip(1)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.radio) {
          this.updateWidgetData(this.radioButtonGroup, formValue);
        }
      });

    this.dataPickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.date) {
          this.updateWidgetData(this.dataPickerGroup, formValue);
        }
      });

    this.geoGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.geotag) {
          this.updateWidgetData(this.geoGroup, formValue);
        }
      });

    this.geoFenceGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.geofence) {
          this.updateWidgetData(this.geoFenceGroup, formValue);
        }
      });

    

    this.separatorGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.separator) {
          this.updateWidgetData(this.separatorGroup, formValue);
        }
      });

    this.imageUploaderGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.imageUploader) {
          this.updateWidgetData(this.imageUploaderGroup, formValue);
        }
      });

    this.faceIdGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.faceId) {
          this.updateWidgetData(this.faceIdGroup, formValue);
        }
      });

    this.touchIdGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.fingerPrint) {
          this.updateWidgetData(this.touchIdGroup, formValue);
        }
      });

    this.sectionGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {

        this.updateSectionData(formValue);
      });

    this.definedFormGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {

        this.updateSectionData(formValue);
      });


    this.scannerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.scanner) {
          this.updateWidgetData(this.scannerGroup, formValue);
        }
      });

    this.dataListGroup.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe((formValue) => {
      this.updateDataListWidget(formValue);

    })

    this.dataBoardGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe((formValue) => {
      this.updateDataBoardwidget(formValue);

    })

    this.overviewTrackerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe((formValue) => {
      this.updateoverviewTrackerwidget(formValue);
    })
   
    this.valuesForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data:any)=>{
      this.lableExisted = false;
        if(this.dataSourceValues.includes(data.label)){
          this.lableExisted = true;
        }
        if(this.editMode && this.dataSourceValues[this.selectedDataSourceIndex] == data.label){
        this.lableExisted = false;
        }
    })

    this.imagePickerGroup.get('uploadType')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if(!isNullOrUndefined(value)) this.resetImgVidFields(value.toUpperCase())
    });

    this.chatBotConfigurationForm.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)).
        subscribe((formValue) => {
         this.updateWidgetData(this.chatBotConfigurationForm, formValue);
    }) 
  }
  patchDropDownDataSourceEntityMappings(entityIds:any,array:FormArray,mappings?:any){

    let currentMappings:any = [];
    let tempMappings = {}
    if(mappings){
      currentMappings = mappings.map((entitymapping:any) => entitymapping.entityId); 
      tempMappings = structuredClone(mappings)
    }else{
      currentMappings = array.getRawValue().map((entitymapping:any) => entitymapping.entityId);
      tempMappings = structuredClone(array.getRawValue());
    }

    if(mappings && entityIds){
      array.clear();
      entityIds.forEach((entityId:string) => {
          array.push(this.createEntityWidgetFormGroup(entityId,this.getSeletedBasedWidgets(entityId,tempMappings),this.getSeletedBasedWidgetsItemsMapping(entityId,tempMappings)))
      })
    }else if(entityIds){
      entityIds.forEach((entityId:string) => {
          if(!currentMappings.includes(entityId)){
            array.push(this.createEntityWidgetFormGroup(entityId,this.getSeletedBasedWidgets(entityId,tempMappings),[]))
          }
        })

        currentMappings = array.getRawValue().map((entitymapping:any) => entitymapping.entityId);
      if(entityIds.length !== array.length){
        currentMappings.forEach((entityId:any) => {
          if(!entityIds.includes(entityId)){
            this.removeEntityById(entityId,array);
          }
        })
      }

    }
    // this.dropdownBasedWidgetsArray.clear();
    this.dropdownDatasourceEntityForm.updateValueAndValidity();

  }

  removeEntityById(entityId: string,array:FormArray) {
    const formArray = array;
    const index = formArray.controls.findIndex(
      (control) => control.value.entityId === entityId
    );
  
    if (index !== -1) {
      formArray.removeAt(index);
    }
  }

  createEntityWidgetFormGroup(entityId: string, basedWidgets: any,basedWidgetControlMapping:any): FormGroup {
    let tempGroup = new FormGroup({
      entityId: new FormControl(""),
      basedWidgets: new FormControl([]),
      basedWidgetControlMapping:this._formBuilder.array([])
    });

    tempGroup.patchValue({entityId:entityId,basedWidgets:basedWidgets,basedWidgetControlMapping:basedWidgetControlMapping});
    return tempGroup;
  }

  addMapping(index: number) {
    const mappingArray = this.dropdownBasedWidgetsArray.at(index).get('basedWidgetControlMapping') as FormArray;
    mappingArray.push(this._formBuilder.group({
      // Your mapping properties
    }));
  }

  addItemsInbasedWidgetControlMappingArray(event:any,index:number,filtergroup:any,mappings?:any){
    let widgets = event.value;
    let currentMappings:any = [];
    let tempMappings = {}
    let array : FormArray = filtergroup.get("basedWidgetControlMapping") as FormArray
    if(array){

      if(mappings){
        currentMappings = mappings.map((mapping:any) => mapping.widgetId); 
        tempMappings = structuredClone(mappings)
      }else{
        currentMappings = array.getRawValue().map((mapping:any) => mapping.widgetId);
        tempMappings = structuredClone(array.getRawValue());
      }
  
      if(mappings){
        mappings.forEach((mapping:any) => {
            array.push(new FormGroup({
              widgetId:new FormControl(mapping.widgetId),
              dependentValue:new FormControl(mapping.dependentValue,Validators.required)
            }))
        })
      }else  if(widgets){
        widgets.forEach((widgetId:any) => {
              if(!currentMappings.includes(widgetId)){
                array.push(new FormGroup({
                  widgetId:new FormControl(widgetId),
                  dependentValue:new FormControl('',Validators.required)
                }))
              }
            })

        currentMappings = array.getRawValue().map((mapping:any) => mapping.widgetId);
        if(widgets.length !== array.length){
          currentMappings.forEach((widgetId:any) => {
            if(!widgets.includes(widgetId)){
              const index = array.controls.findIndex((control) => control.value.widgetId === widgetId);
              if (index !== -1) {
                array.removeAt(index);
              }
            }
          })
        }
    }

    }
    // this.dropdownBasedWidgetsArray.clear();
    this.dropdownDatasourceEntityForm.updateValueAndValidity();
  }

  getSeletedBasedWidgets(entityId:string,mappings:any){
    const mapping = mappings.find((entitywidgetMapping:any) => entitywidgetMapping.entityId === entityId);
    return mapping?.basedWidgets ?? [];
  }
  getSeletedBasedWidgetsItemsMapping(entityId:string,mappings:any){
    const mapping = mappings.find((entitywidgetMapping:any) => entitywidgetMapping.entityId === entityId);
    return mapping?.basedWidgetControlMapping ?? [];
  }

  get dropdownBasedWidgetsArray(){
    return this.dropdownDatasourceEntityForm.get('basedWidgetIds') as FormArray;
  }
  get dropdownDataSourceFilters(){
    return this.dropdownDatasourceEntityForm.get('filters') as FormArray;
  }

  async setEntityWidgetsMapping(entities:any){
     let entitysAndRelatedWidgets: any = this.entitiesWidgetsMaping;
      if(entities){
        for (const entity of entities) {
          const entityId = entity;
          if (!this.entitiesWidgetsMaping[entityId]) {
            let response : any = await firstValueFrom(this.wformService.fetchEntity(entityId,this.applicationId))
            entitysAndRelatedWidgets[entityId] = this.wformService.retriveWidgetsListFromEntiywithConfig(response.data?.page_widget_details);
          }
        }
      }

      this.entitiesWidgetsMaping = entitysAndRelatedWidgets;
      this.entitiesWidgetsMappingObj = this.transformObject(this.entitiesWidgetsMaping);
  }

  transformObject(input:any) {
    const output:any = {};
    for (const key in input) {
      if (Array.isArray(input[key])) {
        output[key.toLowerCase()] = input[key].reduce((acc:any, item:any) => {
          if (item.widgetId) {
            acc[item.widgetId] = item;
          }
          return acc;
        }, {});
      } else {
        output[key.toLowerCase()] = input[key];
      }
    }
    return output;
  }

  getEntityRelatedWidgets(entitywidgetMapping:any,entityIndex:any) : any{
    return this.entitiesWidgetsMaping[entitywidgetMapping.value.entityId] ?? [];
  }

  getSelectedEntityName(entitywidgetMapping:any){
    let entity = this.entityList.find((entity:any) => entity.entity_id === entitywidgetMapping.value.entityId);
    if(entity){
      return entity.entity_name;
    }else{
      return "";
    }
  }
  
 

  buildDataBoardCustomHeaders(event:any){
    if(event.checked){
      let customLabels : any = [];
      if(this.dataBoardGroup.get('primary')?.value){
        customLabels.push({
          original:this.dataBoardGroup.get('primary')?.value,
          custom:''
        })
      } 
      if(this.dataBoardGroup.get('secondary')?.value){
        customLabels.push({
          original:this.dataBoardGroup.get('secondary')?.value,
          custom:''
        })
      }
      this.dataBoardGroup.get('lhsItemsCustomLabel')?.setValue(customLabels);
    }else{
      this.dataBoardGroup.get('lhsItemsCustomLabel')?.reset();
    }
  }

  updateDataBoardwidget(values:any){
    const { label,type,primary,secondary,headertype,customHeader,aggregate,maxRows,lhsItemsCustomLabel,entityId,widgetId } = values;
    this.selectedWidgetMetaData.widgetLabel = label;
    this.selectedWidgetMetaData.widgetConfig['dataListWidgetConfig'] = { type,primary,secondary,headertype,customHeader,aggregate,lhsItemsCustomLabel,entityId,widgetId };
    this.selectedWidgetMetaData.widgetConfig['dataListWidgetConfig']['maxRows'] = maxRows;
    const {serialNumber,search,download,downloadType,widgets,fileType} = values;
    this.selectedWidgetMetaData.widgetConfig['additionalConfig'] = {serialNumber,search,download,downloadType,widgets,fileType};
    this.selectedWidgetMetaData.widgetDataSource = {
      "datasourceType": 'api',
      "datasource": values.dataSource,
    }
  }

  updateoverviewTrackerwidget(formValue:any){
    const { info,infoDescription,legend,entityId,label,primary,secondary,statuses,statusesColorCode,statusLabel} = formValue;
    this.selectedWidgetMetaData.widgetLabel = label;
    this.selectedWidgetMetaData.widgetConfig['overviewTrackerConfig'] = {primary,secondary,info,infoDescription,legend,entityId,statuses,statusesColorCode,statusLabel };
    if(statusesColorCode && statusesColorCode.length > 0){
      let statusesColorObj : any = {};
      statusesColorCode.forEach((statusObj:any) => {
        statusesColorObj[statusObj.status] = {
          bgColor:statusObj.bgColor,
          textcolor:statusObj.textColor
        }
      });
      this.selectedWidgetMetaData.widgetConfig['additionalConfig']['statusesColorObj'] = statusesColorObj;
    }
    this.selectedWidgetMetaData.widgetConfig['additionalConfig']['serialNumber'] = formValue.serialNumber;
    this.selectedWidgetMetaData.widgetConfig['additionalConfig']['search'] = formValue.search;
    this.selectedWidgetMetaData.widgetDataSource = {
      "datasourceType": 'api',
      "datasource": formValue.dataSource,
    }
  }

  statusColorCodeUpdater(event:string,currentStatus:string,colorType:string){
    if(this.selectedWidgetMetaData.widgetConfig.additionalConfig?.statusesColorObj){
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.statusesColorObj[currentStatus][colorType] = event;
    }
  }

  statusTracerStatusesSelectionChange(event:any){
    const selectedStatuses:any = event.value;
    const updatedStatusList:any = [];
    selectedStatuses.forEach((status: string) => {
        updatedStatusList.push({
          status: status,
          bgColor: '#fdf7ee', textColor: '#d5b582'
        });
    });
    this.overviewTrackerGroup.get('statusesColorCode')?.setValue(updatedStatusList);
  }

  
  //#region  data source 

  deleteDatasourceValue(i: number) {
    this.dataSourceValues.splice(i, 1);
  }

  removeDataSource(index: number) {
    const dataSourceArray = this.valuesForm.get('dataSource') as FormArray;
    dataSourceArray.removeAt(index);
  }

  addDataSourceValue() {
    if (!this.dataSourceValues) {
      this.dataSourceValues = [];
    }
    if (this.valuesForm.valid && !this.lableExisted) {
      const newValue = this.valuesForm.get('label')?.value;
      if (!this.dataSourceValues.includes(newValue)) {
        this.dataSourceValues.push(newValue);
      }
      this.valuesForm?.get('label')?.reset();    
    }
  }

  updateDataSource(value: any) {
    if (this.apiForm.valid) {
      const apiUrl = value['apiUrl'];
      const method = value['method'];
      const apiId = value['apiId'];
      const payload = this.msFieldslist ? this.msFieldslist : [];
      const responseParameter = value['responseParameter'];
      const authApiUrl = value['authApiUrl'];
      const authType = value['auth'];
      const apiKey = value['apiKey'];

      let dataSource = {
        "datasourceType": "api",
        "datasource": apiUrl,
        "request-parameter": payload,
        "response-parameter": responseParameter,
        "method": method,
        "apiId":apiId,
        "Authorization": {
          "auth-api-url": authApiUrl,
          "auth": authType,
          "api-key": apiKey,
        }
      }

      this.selectedWidgetMetaData.widgetDataSource = dataSource;
      // this.makeApiCall();

      if (this.page.pageId)
        this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, this.selectedWidgetMetaData);
    }
  }


  fetchKeysFromAPI(data: any) {
    if (Array.isArray(data)) {
      this.apikeys = Object.keys(data[0]);
    }
    else if (data) {
      this.apikeys = Object.keys(data);

    }
  }

  fetchKeysFromAuthAPI(data: any) {
    if (Array.isArray(data)) {
      this.authApikeys = Object.keys(data[0]);
    }
    else if (data) {
      this.authApikeys = Object.keys(data);

    }
  }


  async makeApiCall(event:any,apiID?:string,) {

    let apiId:string;
    let apiResponce:any;
    if(apiID){
      apiId = apiID;
    }else{
      typeof(event) !== 'object' ? apiId = event : apiId = event.value;
    }
    let selectedApi = this.userApis.find((api:any) => api.apiId === apiId);
    if(!selectedApi){
      this.predefinedSelected = true;
      let selectedApi = this.preConfiguredApis.find((api:any) => api.apiId === apiId);
      if(selectedApi){
        apiResponce = selectedApi.apiResponce;
      }else{
        apiResponce = [{}];
      }
    }else{
      this.preConfiguredApis = false;
      if(selectedApi.authenticatedApiId){
        let authApi = this.authApis.find((api:any) => api.apiId === selectedApi.authenticatedApiId)
         let authResonce:any = await this.apiConfigService.makeDataSourceAuthApiRequest(authApi.apiURL,authApi.method,authApi.requestBody,authApi.headers);
         let token = this.apiConfigService.getValidTokenFromApi(authResonce);
          if(token){
          selectedApi.headers['Authorization'] =  `Bearer ${token}` ;
          }
         };
         apiResponce = await this.apiConfigService.makeDataSourceApiRequest(
          selectedApi.apiURL,
          selectedApi.method,
          selectedApi.requestBody,
          selectedApi.headers,
        )}
        this.fetchKeysFromAPI(apiResponce);
        if(this.selectedWidgetMetaData.widgetType == this.widgetTypes.dropdown){
          if (Array.isArray(apiResponce)) {
            this.sharedService.setDataSourceApiValues({ widgetId:this.selectedWidgetMetaData.widgetId,responce: apiResponce, field: this.apiForm.get('responseParameter')?.value });
          } else {
            this.toasterService.warning('The Api Does not return list of values');
          }
        }else if(this.selectedWidgetMetaData.widgetType === this.widgetTypes.dataBoard){
          this.selectedWidgetMetaData.widgetConfig["apiResponce"] = apiResponce;
        }
    
  }


  handleApiError(error: any): void {
    if (error.status === 0) {

      this.toasterService.error('CORS error: Unable to make the API call due to cross-origin restrictions.');

    } else {
      this.toasterService.error(error.message);
    }
  }

  async addOrDeletePreviewPage() {
    let preview = this.previewGroup.get('preview')?.value ? this.previewGroup.get('preview')?.value : false;
    let checkPreviewPageInWidget = this.selectedWidgetMetaData.widgetConfig['previewPageId'];
    let previewPageIndex = -1;
    isNullOrUndefined(checkPreviewPageInWidget) ? previewPageIndex = -1 : previewPageIndex = this.pagesList.findIndex((page:any) => page.pageId === checkPreviewPageInWidget);
    if(preview && isNullOrUndefined(checkPreviewPageInWidget)) {
      await this.fetchPreviewScreen();
    }else if(preview == false && previewPageIndex >= 0){
      await this.deletePreviewScreen();
    }
  }
  

  addDataSource(isChartApiRequest?:boolean,selectedApiId?:string,type?:string) {
    const selectedType = this.dataSourceTypeForm.get('dataSourceType')?.value;
    let dataSource:any;

    if(isChartApiRequest){
      dataSource = {
        "datasourceType": type,
        "datasource": selectedApiId,
      }
    }
    else if ((selectedType &&selectedType.toLowerCase() === 'api') ) {

      this.makeApiCall(this.apiForm.get('apiId')?.value);
      let values: string[] = [];
      this.msFieldslist.forEach((field) => {
        values.push(field.widgetKey);
      })

      let apiId = this.apiForm.get('apiId')?.value;
      let selectedApi = this.userApis.find((api:any) => api.apiId === apiId);
      let authApi;
      selectedApi?.authenticatedApiId != null ? authApi = this.authApis.find((api:any) => api.apiId === selectedApi.authenticatedApiId) : null;
      
      dataSource = {
        "datasourceType": "api",
        "datasource": selectedApi.apiURL,
        "apiId":selectedApi.apiId,
        "request-parameter": values,
        "response-parameter": this.apiForm.get('responseParameter')?.value ? { label: this.apiForm.get('responseParameter')?.value } : null,
        "method": selectedApi.method,
        "Authorization":authApi ?  {
          "auth-api-url": authApi?.apiURL,
          "auth": authApi?.authType,
          "api-key": "access_token",
        } : {}
      }

    } else if (selectedType.toLowerCase() === 'manual') {
      let newManualValues: { key: string, label: string }[] = [];

      this.dataSourceValues.forEach((value) => {
        newManualValues.push({ key: '', label: value });
      })
      dataSource = {
        "datasourceType": "manual",
        "datasource": [...newManualValues],
      }
    }else if (selectedType.toLowerCase() === 'stage') {
      dataSource = {
        "datasourceType": "stage",
        "datasource": [],
      }
    }else if (selectedType.toLowerCase() === 'entity') {
      dataSource = {
        "datasourceType": "entity",
        "datasource": this.dropdownDatasourceEntityForm.get('entityId')?.value,
        "response-parameter": this.dropdownDatasourceEntityForm.get('widgetId')?.value ? { label: this.dropdownDatasourceEntityForm.get('widgetId')?.value ?? '',key:this.dropdownDatasourceEntityForm.get('widgetKey')?.value ?? '' } : null,
      }
      dataSource["basedWidgetIds"] = this.wformService.formatInToBasedWidgetIds(this.dropdownDatasourceEntityForm.get('filters')?.getRawValue());
    }


    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    this.widgetMetaEntire.widgetMeta['widgetDataSource'] = dataSource
    apiConfig.postData = {
      'applicationId': this.applicationId,
      'widgetDataSource': dataSource,
      'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      'widgetId': this.widgetId
    }



    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.toasterService.success('Actions Updated Successfully');
      },
      error: (err: any) => {
        this.toasterService.error('Something Went wrong Try again');
      }
    })
  }

  addDataSourceFilter(item:any,index:number){
    if(item === this.dropdownDataSourceFilterTypes.manual){
      let formGroup:FormGroup =  this._formBuilder.group({
        filterType:[this.dropdownDataSourceFilterTypes.manual],
        dependentValue:['',Validators.required],
        ref:['',Validators.required]
      })
      this.dropdownDataSourceFilters.push(formGroup);
    
    }else if(item === this.dropdownDataSourceFilterTypes.widget){
      this.dropdownDataSourceFilters.push( this._formBuilder.group({
          filterType:[this.dropdownDataSourceFilterTypes.widget,],
          basedEntitys:[[],Validators.required],
          basedWidgetIds:this._formBuilder.array([])
      }))
      this.dropdownDataSourceFiltersMenu.splice(index,1)
    }
  }


  removeDataSourceFilter(index:number,filter:any){
    if(filter.filterType === this.dropdownDataSourceFilterTypes.widget){
      this.dropdownDataSourceFiltersMenu.push(this.dropdownDataSourceFilterTypes.widget)
    }
    this.dropdownDataSourceFilters.removeAt(index);
  }

  async fetchAndPatchBasedWntityWidget(event:any,filter:any){
    let entityIds = event.value;
    await this.setEntityWidgetsMapping(entityIds);
    this.patchDropDownDataSourceEntityMappings(entityIds,filter.get('basedWidgetIds') as FormArray);
  }

  //#endregion
  deleteWidgetApi(currentPageData: PAGEI, formIndex: number, widgetId: any) {
    this.sharedService.deleteWidget(currentPageData, formIndex, widgetId);
  }

  deleteWidget() {
    this.deleteWidgetApi(this.page, this.sectionIndex, this.widgetIndex);
  }


  //#endregion


  updateWidgetLabel() {
    const newLabel = this.textFieldGroup.get('label')?.value;
    this.sharedService.setWidgetLabel(newLabel, this.widgetId);
  }


  updateWidgetPlaceholder() {
    const newPlaceholder = this.textFieldGroup.get('placeholder')?.value;
    this.sharedService.setWidgetPlaceholder(newPlaceholder, this.widgetId);
  }
  updateWidgetTextColor() {
    const newTextColor = this.textFieldGroup.get('textColor')?.value;
    this.sharedService.setWidgetTextColor(newTextColor, this.widgetId);
  }


async  onFileSelected(event: any, widgetType: string) {
    this.spinnerActive = true;
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      this.imageUploaderPhoto = selectedImage;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;

          image.onload = async () => {
          this.imageUploaderSrc = e.target.result;
          if (this.page.pageId) {
            let widgetId = this.selectedWidgetMetaData.widgetId;
            let updating = false;
            let image = '';
            if(widgetType === this.widgetTypes.chatBot) {
              image = this.selectedWidgetMetaData.widgetConfig?.additionalConfig?.uploadedAvatar ?? ''; 
              this.chatBotConfigurationForm.get('avatarFileName')?.patchValue(selectedImage.name)
            }
            else {
              image = this.selectedWidgetMetaData.widgetConfig.image ? this.selectedWidgetMetaData.widgetConfig.image : '';
            }
            updating = image.includes('mobiwise.s3')
            const parts: string[] = image.split('/');
              this.spinnerActive = false;
              if(widgetType === this.widgetTypes.chatBot) {
                let result : any = await this.sharedService.updateWidgetImage(selectedImage, widgetId,updating ? parts[parts.length - 1]:undefined );
                if(result.status){
                  this.chatBotConfigurationForm.get('uploadedAvatar')?.patchValue(result.response.image);
                  this.selectedWidgetMetaData.widgetConfig.additionalConfig.uploadedAvatar = result.response.image;
                  this.s3ImageUrl = result.response.image +'?time='+new Date().getTime();
                }else{
                  this.toasterService.error('Failed to upload image,please try again')
                }
              } else {
                this.s3ImageUrl = this.imageUploaderSrc;
                this.selectedWidgetMetaData.widgetConfig['image'] = this.imageUploaderSrc;
              }
          }
        }
      }
      reader.readAsDataURL(selectedImage);
    }else{
      this.spinnerActive = false;
    }
  }

  async updateWidgetImage(){
    this.spinnerActive = true;
    let image = this.selectedWidgetMetaData.widgetConfig.image ?? '';
    let updating =  image.includes('mobiwise.s3')
    const parts: string[] = image.split('/');
    let result : any = await this.sharedService.updateWidgetImage(this.imageUploaderPhoto, this.selectedWidgetMetaData.widgetId,updating ? parts[parts.length - 1]:undefined );
    if(result.status){
          this.s3ImageUrl = result.response.image +'?time='+new Date().getTime();
          this.selectedWidgetMetaData.widgetConfig['image'] = this.s3ImageUrl;
    }else{
      this.toasterService.error('Failed to upload image,please try again')
    }
    this.spinnerActive = false;
  }

  async updateWidgetImageAndValues(){
    // await this.updateWidgetImage();
    this.updateWidgetValues();
  }

  cropImage(){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
      disableClose: true,
      data: {
       imageUrl:this.s3ImageUrl
     }
   })

   dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(async (result:any) => {

     if (typeof (result) !== 'boolean' && result !== undefined) {
       if (this.page.pageId) {
          this.imageUploaderPhoto = result.croppedImageFile;
          this.s3ImageUrl = result.croppedImageUrl;
          this.selectedWidgetMetaData.widgetConfig['image'] = result.croppedImageUrl;
      }
     }
   });
 }


  async getImageFile(widget:any) {
    const image = widget.widgetConfig.image;
    if(widget.widgetConfig.additionalConfig && widget.widgetConfig.additionalConfig['imagePath']){
      this.blobUrl = await this.streamimage(widget.widgetConfig.additionalConfig['imagePath']);
      this.loading = false;
    } else if (!image || image === "image") {
      this.s3ImageUrl = this.defaultImgSrc;
      this.loading = false;
    }else{
      this.s3ImageUrl = this.sharedService.getModifiedImageUrl(image);
      this.loading = false;
    }
  }

  async streamimage(imagePath: string) {
   const blobUrl : string = await this.streamBlobService.fetchImage(imagePath);
   return blobUrl;
  }

  //#region chips multi select add values

  // multi select enter values in conditional action
  addItemValue(item: any, event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      item.values.push({ name: value });
    }

    event.chipInput!.clear();
  }

  removeItemValue(value: string, item: any): void {
    const index = item.values.indexOf(value);

    if (index >= 0) {
      item.values.splice(index, 1);
    }
  }

  editItemValue(value: string, item: any, event: MatChipEditedEvent) {
    const valueItem = event.value.trim();

    if (!valueItem) {
      this.removeItemValue(value, item);
      return;
    }
    const index = item.values.indexOf(value);
    if (index >= 0) {
      item.values[index] = valueItem;
    }
  }

  patchStyleProperties(form: any, widget: any) {
    form.patchValue({
      bold: widget?.widgetConfig?.style["font-weight"] == 'bold',
      italic: widget?.widgetConfig?.style["font-style"] == 'italic',
      underline: widget?.widgetConfig?.style["text-decoration"] == 'underline',
      fontSize: !isNullOrUndefined(widget?.widgetConfig?.style?.["font-size"]) && widget?.widgetConfig?.style?.["font-size"] != 'none' ? parseInt(widget?.widgetConfig?.style?.["font-size"]) : 16
    })
  }
  //#endregion


  //#region authDataSource model


  addField(): FormGroup {
    return this._formBuilder.group({
      widgetId: '',
    });
  }

  patchField(data: any): FormGroup {
    return this._formBuilder.group({
      widgetId: data,
    });
  }

  updateFilterWidget(data: any, widgetType?: string) {
    let filterArray = [];

    if (widgetType === this.widgetTypes.plainText) {
        filterArray = data.filter((widget: any) => 
            ALLOWED_INPUT_WIDGET_TYPES.includes(widget.widgetType)
        );
    } else {
        filterArray = data.filter((widget: any) => 
            ALLOWED_ITEM_FROM_WIDGET_LIST_FOR_DATALISTPAGE.includes(widget.widgetType)
        );
    }

    return filterArray; // Always return the filtered array
}

updateWidgetRef(event:any){
  if(this.page?.pageId){
    this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, event);
  }
}


  downloadPdfFieldsSelection(event: MatSelectChange,formGroup:FormGroup) {
    const selectedValue = event.value;

    selectedValue.forEach((item: string) => {
      if (!this.downloadPdfSequencelist.includes(item)) {
        this.downloadPdfSequencelist.push(item); 
      }
    });
   
    this.downloadPdfSequencelist = this.downloadPdfSequencelist.filter(item => selectedValue.includes(item));   // Remove deselected items
    formGroup.get('widgets')?.setValue(this.downloadPdfSequencelist);
  }

  getFilteredOptions(index: number, type: any): any[] {
    if(type != 'all'){
      const selectedOptions = type === 'lhs'
        ? this.lhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value)
        : this.rhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value);
      const otherSideOptions = type === 'lhs'
        ? this.rhsItems.controls.map((control: any) => control.get('widgetId').value)
        : this.lhsItems.controls.map((control: any) => control.get('widgetId').value);
      this.filterWidgetList =this.listOfWidgetsOfEntity.filter((widget: any) => {
        return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);
      });

      return this.filterWidgetList.filter((option: any) =>
        !selectedOptions.includes(option.widgetId) && !otherSideOptions.includes(option.widgetId)
      );
    }else{
      
      return this.listOfWidgetsOfEntity.filter((widget: any) => {
        return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);})
    }
  }

  getGroupByOptions(): any[] {
    if(this.listOfWidgetsOfEntity.length > 0) {
      return this.listOfWidgetsOfEntity.filter((widget: any) => {
        return ALLOWED_ITEM_FROM_WIDGET_LIST.includes(widget.widgetType);
      });
    }else {
      return [];
    }
  }

  addLhsFieldsInCard() {
    this.isLhsclicked = true;
    this.lhsItems.push(this.addField());
  }

  removeLhsFieldsInCard(index: number,widgetId:string) {
    this.lhsItems.removeAt(index);
    if(this.selectedWidgetMetaData?.widgetConfig?.additionalConfig?.sort){
      this.formatSortValue(widgetId);
    }
  }

  addRhsFieldsInCard() {
    this.isRhsclicked = true;
    this.rhsItems.push(this.addField())
  }

  removeRhsFieldsInCard(index: number,widgetId:string) {
    this.rhsItems.removeAt(index);
    if(this.selectedWidgetMetaData?.widgetConfig?.additionalConfig?.sort){
      this.formatSortValue(widgetId);
    }
    // this.selectedWidgetMetaData.widgetConfig.additionalConfig.
  }

  formatSortValue(widgetId:string){
    const defaultSortFields = this.selectedWidgetMetaData.widgetConfig.additionalConfig.defaultSortField;
    if (Array.isArray(defaultSortFields)) {
      // If defaultSortField is already an array, remove the widgetId if present
      const index = defaultSortFields.indexOf(widgetId);
      if (index > -1) {
        defaultSortFields.splice(index, 1);
      }
    } else {
      // If defaultSortField is not an array, initialize it as empty array
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.defaultSortField = [];
    }
    const sortFields = this.selectedWidgetMetaData.widgetConfig.additionalConfig.sortFields;
      const index = sortFields.findIndex((item: any) => item === widgetId);
      if (index !== -1) {
        sortFields.splice(index, 1);
        this.dataListGroup.patchValue({sortFields:sortFields});
      }
  }

  getEntitiesOrAttributes(payload: any): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
      apiConfig.postData = payload
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data?.data); 
          observer.complete(); 
        },
        error: (error: any) => {
          if(error?.status == 403) {
            this.toasterService.error('You do not have permission to access this resource.');
          }
          observer.error(error);
          observer.complete();
        }
      });
    })
  }

  formatListOfwidgetsOfEntity(list: any) {
    list?.forEach((item: any) => {
      item.show = false;
    })
    return list;
  }
  async onEntitySelected(event?:any,addStatus?:boolean) {
    this.lhsItems.clear();
    this.rhsItems.clear();
    const payload = {
      application_id: this.applicationId,
      entity_id: event?.value ?? this.dataListGroup.value.entity,
      project_id: null,
      parent_entity_id: null
    }
    const listOfPageWidgetsOfEntity = await this.getEntitiesOrAttributes(payload).toPromise();
    this.pageIdsOfAssociatedEntity = listOfPageWidgetsOfEntity?.page_ids ?? [];
    this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details)
    this.listOfWidgetsOfEntity.push({
      widgetId: "created_date",
      widgetLabel:"Created Date",
      widgetType:this.widgetTypes.date})
    this.listOfWidgetsOfEntity = this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
    this.filterWidgetList = this.updateFilterWidget(this.listOfWidgetsOfEntity,this.selectedWidgetMetaData.widgetType);
    if(addStatus){
      let standerkeys = STANDERD_ADDITIONAL_WIDGETS
      if(this.selectedWidgetMetaData.widgetType === this.widgetTypes.filter){
        let extrafields = this.wformService.getUserExtraFields();
        if(isNullOrUndefined(extrafields)){
          await this.wformService.fetchAdditionalFields();
          extrafields = this.wformService.getUserExtraFields();
        }
        extrafields = extrafields.map((field: string) => ({
          widgetId: field,
          widgetLabel: field.replace(/_/g, ' ')
        }));
        standerkeys = [...standerkeys,...extrafields]
      }
       this.dataBoardEntityBasedWidgets = [...standerkeys,...this.filterWidgetList];
       this.filterBasedOnfiledWidgetOptions = this.dataBoardEntityBasedWidgets;
    }
  }

  clearEntitySeletion(formGroup:FormGroup){
    formGroup?.get('linkEntityId')?.reset();
    formGroup?.get('linkEidgetId')?.reset();
  }

  selectAllDataListWidgets(event:any){
      this.dataListWidgetSelectAllToggle = event.checked;
      this.listOfWidgetsOfEntity.forEach((widget:any) => widget.show = event.checked);
      this.updateWidgetValues();
  }

  updateSelectAllToggleStatus(){
    let allSelected = true;
    this.listOfWidgetsOfEntity.some((widget:any) => {
      if(!widget.show){
        allSelected = false;
      }
    })
    this.dataListWidgetSelectAllToggle = allSelected;
  }

  private previousWidgetData: any = null;

  updateDataListWidget(widgetData: any) {
    // Compare new data with previous data to prevent unnecessary updates
    if (this.isEqual(widgetData, this.previousWidgetData)) {
      return;
    }
    this.previousWidgetData = { ...widgetData };

    const selectedWidgetMetaDataWidgetConfig = this.selectedWidgetMetaData.widgetConfig;
    selectedWidgetMetaDataWidgetConfig.dataListWidgetConfig = {
      type: widgetData.type,
      entityId: widgetData.entity,
      entryPageId: widgetData.entryPageId,
      lhsItems: this.formatItemsArray(widgetData.lhsItems),
      rhsItems: this.formatItemsArray(widgetData.rhsItems),
      listOfWidgetsOfEntity: this.listOfWidgetsOfEntity
    }

    // Only update sort config if sort is enabled
    const sortConfig = this.dataListGroup.get('sortConfig') as FormArray;
    if (widgetData.sort) {
      const sortFields = widgetData.sortFields || [];

      // Remove entries from sortConfig that are not in sortFields
      for (let i = sortConfig.length - 1; i >= 0; i--) {
      const mapping = sortConfig.at(i).value;
      if (!sortFields.includes(mapping.widgetId)) {
        sortConfig.removeAt(i);
      }
      }

      // Add new sort fields
      sortFields.forEach((field: string) => {
      const exists = sortConfig.controls.some(control => control.value.widgetId === field);
      if (!exists) {
        let label = this.getCombinedWidgetLabel(field);
        sortConfig.push(
        this._formBuilder.group({
          widgetId: [field, Validators.required],
          label: [label, Validators.required],
          appliesTo: [[field], Validators.required]
        })
        );
      }
      });
    }

    selectedWidgetMetaDataWidgetConfig.additionalConfig = {
      delete: widgetData.delete,
      download: widgetData.download,
      downloadType: widgetData.download ? widgetData.downloadType : '',
      widgets: widgetData.widgets,
      fileType: widgetData.fileType,
      filter: widgetData.filter,
      search: widgetData.search,
      groupBy: widgetData.groupBy,
      mysubmission: widgetData.mysubmission,
      edit: widgetData.edit,
      entryPageId: widgetData.entryPageId,
      sort: widgetData.sort,
      defaultSortType: widgetData.sort ? widgetData.defaultSortType : '',
      defaultSortField: widgetData.sort ? widgetData.defaultSortField : [],
      sortFields: widgetData?.sort ? widgetData.sortFields : [],
      sortConfig: widgetData?.sort ? sortConfig.value : [], 
    };

    this.selectedWidgetMetaData.widgetConfig = selectedWidgetMetaDataWidgetConfig;
    if (this.page.pageId) {
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetIndex, this.selectedWidgetMetaData);
    }
  }

  private isEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  formatItemsArray(widgetsArray: any) {
    widgetsArray?.forEach((item: any) => {
      const widgetData = this.listOfWidgetsOfEntity?.filter((x: any) => x.widgetId == item.widgetId)?.[0]
      item.widgetLabel = widgetData?.widgetLabel;
      item.widget_type = widgetData?.widgetType;    })
    return widgetsArray;
  }

  async createOrUpdateDataListViewPage(isLineItem?:boolean) {
    this.isDataListViewPageCreating = true;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_DATALIST_VIEWPAGE']);
    apiConfig.postData = {
      applicationId: this.applicationId,
      entityId: this.dataListGroup.value.entity,
      entityName: this.listOfEntitiesOfApplication?.filter((x: any) => x.entity_id == this.dataListGroup.value.entity)?.[0]?.entity_name,
      widgetId: this.selectedWidgetMetaData.widgetId,
      listOfWidgetsOfEntity: this.listOfWidgetsOfEntity,
      pageIdsOfEntity: this.pageIdsOfAssociatedEntity
    }
    if(this.selectedWidgetMetaData.widgetConfig?.dataListViewPageId){
      this.pagesList.find((page:any) => page.pageId === this.selectedWidgetMetaData.widgetConfig?.dataListViewPageId) ? apiConfig.postData['dataListViewPageId'] = this.selectedWidgetMetaData.widgetConfig?.dataListViewPageId : null;
    }
    if(isLineItem){
      let lineItemConfig = this.selectedWidgetMetaData.widgetConfig?.additionalConfig['lineItemConfig'];
      lineItemConfig["listOfWidgetsOfEntity"] = this.listOfWidgetsOfEntity;
      apiConfig.postData["entityId"] = lineItemConfig.entityId;
      apiConfig.postData["entityName"] = this.entityList?.filter((x: any) => x.entity_id == lineItemConfig.entityId)?.[0]?.entity_name;
    }
    const data = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          this.selectedWidgetMetaData.widgetConfig['dataListViewPageId'] = response?.dataListViewPageId;
          this.pagesList.find((page:any) => page.pageId === this.selectedWidgetMetaData.widgetConfig?.dataListViewPageId) ? null :  this.pagesList.push({pageId: response?.dataListViewPageId,pageType: this.pageTypes.dataListView});
         
          this.pageRearrangeService.updateOrder(this.applicationId,this.pagesList.map((page:any) => page.pageId), response?.dataListViewPageId, 'add');
          this.currentWidgetPreviewPageExits = true;
          resolve(response);
        },
        complete: () => {
          if(isLineItem){
            this.updateWidgetValues()
          }
         this.sharedService.getAllPagesRefreshActionTrigger();
          setTimeout(() => {
            this.isDataListViewPageCreating = false;
          }, 100)
        },
        error: (err : any) => {
          if(err?.status == 403) {  
            this.toasterService.error('You do not have permission to access this resource.');
          }
          this.toasterService.error('Failed to create Data list view page');
          this.isDataListViewPageCreating = false;
          resolve(err);
        }
      });
    })
  }

  async datalistPreviewSetter(){
    this.dataLoading = true
    if(this.selectedPageData.pageType === this.pageTypes.dataListView && this.hasLineItemAction(this.selectedWidgetMetaData.widgetConfig)){
      let lineItemConfig = this.selectedWidgetMetaData.widgetConfig?.additionalConfig['lineItemConfig'];
      if(lineItemConfig){
        const payload = {
          application_id: this.applicationId,
          entity_id: lineItemConfig.entityId,
          project_id: null,
          parent_entity_id: null
        }
        const listOfPageWidgetsOfEntity = await this.getEntitiesOrAttributes(payload).toPromise();
        this.pageIdsOfAssociatedEntity = listOfPageWidgetsOfEntity?.page_ids ?? [];
        this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details)
        this.listOfWidgetsOfEntity = this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
        this.filterWidgetList = this.updateFilterWidget(this.listOfWidgetsOfEntity);

        if("listOfWidgetsOfEntity" in lineItemConfig){
          const widgetConfigMap = new Map((lineItemConfig.listOfWidgetsOfEntity || []).map((item: any) => [item.widgetId, item]));
          const formatedList = (this.listOfWidgetsOfEntity || []).map((item: any) => {
            const configItem = widgetConfigMap.get(item.widgetId);
            return configItem ? configItem : item;
          });
          this.listOfWidgetsOfEntity = lineItemConfig.listOfWidgetsOfEntity
            ? formatedList
            : this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
        }
      }
      this.dataLoading = false
    }else{
      this.currentWidgetPreviewPageExits = this.pagesList.some(
        page => page.pageId === this.selectedWidgetMetaData?.widgetConfig?.dataListViewPageId
      );
      !this.currentWidgetPreviewPageExits && this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
    }
    this.updateSelectAllToggleStatus();
  }

  hasLineItemAction(widgetConfig:any){
   let actionAvailable = widgetConfig.actions.some((action:any) => action.action_type === this.widgetClickActionTypes.lineItem) ?? false;
    return actionAvailable;
  }

  async fetchPreviewScreen() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_PREVIEW']);

    apiConfig.postData = {
      applicationId: this.applicationId,
      pageId: this.page.pageId,
      widgetId: this.selectedWidgetMetaData.widgetId
    }

    const data = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          this.selectedWidgetMetaData.widgetConfig['previewPageId'] = response?.previewPageId;
          resolve(response);
        },
        complete: () => {
          this.sharedService.getAllPagesRefreshActionTrigger();
        },
        error: (err : any) => {
          if(err?.status == 403) {
            this.toasterService.error('You do not have permission to access this resource.');
          }
          resolve(err);
        }
      })
    }) 
  }

  async deletePreviewScreen() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PREVIEW']);
    apiConfig.postData = {
      applicationId: this.applicationId,
      previewPageId : this.selectedWidgetMetaData.widgetConfig?.previewPageId ? this.selectedWidgetMetaData.widgetConfig?.previewPageId : "",
      widgetId: this.selectedWidgetMetaData.widgetId
    }
    const data  = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        complete: () => {
          delete this.selectedWidgetMetaData.widgetConfig['previewPageId'];
          this.sharedService.getAllPagesRefreshActionTrigger();
        },
        error: (err : any) => {
          if(err?.status == 403) {
            this.toasterService.error('You do not have permission to access this resource.');
          }
          resolve(err);
        }
      })

    })
  }

  retriveWidgetsListFromEntiy(pageWidgetDetails: any) {
    return pageWidgetDetails?.flatMap((page: any) =>
        page.widget_details.map((widget: any) => ({
          widgetId: widget.widgetId,
          widgetLabel: widget.widgetLabel,
          widgetType: widget.widgetType
        }))
      ) || [];
    }

  isEntityClicked(){
    this.isEntityTouched = true; 
  }

  editDatasourceValues(index: any) {
    this.editMode = true
    this.selectedDataSourceIndex = index
    const existingValue = this.dataSourceValues[index];
    this.editedDataSourceValue = existingValue
    this.valuesForm.patchValue({
      label: existingValue,
    });

  }
  updateEditedDataSource() {
    if(this.valuesForm.valid && !this.lableExisted){
      const newValue = this.valuesForm.get('label')?.value;
      const index = this.dataSourceValues.indexOf(this.editedDataSourceValue);
      if (this.dataSourceValues.includes(newValue)) {
        this.editMode = false;
      } else if (index !== -1) {
        this.dataSourceValues[index] = newValue;
        this.editMode = false;
      }
      this.valuesForm.reset();
    }
  }

  preventScroll(event: WheelEvent): void {
    event.preventDefault();
  }

  resetImgVidFields(type: keyof typeof IMGVIDPICKER_CONSTANTS) {
      const config = IMGVIDPICKER_CONSTANTS[type].CONFIGS?.filter((config: string) => (config !== 'Compression' ));
      const formgroup = this.imagePickerGroup
      this.resetFields(config, formgroup);
  }

  resetFields(fields: string[], formgroup: FormGroup) {
    fields.forEach(field => {
      const control = formgroup.get(field);
      if (control) {
        control.reset();
        control.markAsPristine();
        control.markAsUntouched();
      }
    });
  }


  dateRangeValidator(control: AbstractControl): ValidationErrors | null {
    const maxDateRangeControl = control.get('maxDateRange');
    const minDateRangeControl = control.get('minDateRange');

    if (maxDateRangeControl && minDateRangeControl) {
      const maxDateRange = parseInt(maxDateRangeControl.value);
      const minDateRange = parseInt(minDateRangeControl.value);

      if (maxDateRange < 0) {
        maxDateRangeControl.setErrors({ min: true });
        return { min: true };
      }

      if (minDateRange < 0) {
        minDateRangeControl.setErrors({ min: true });
        return { min: true };
      }

      if (maxDateRange <= minDateRange) {
        maxDateRangeControl.setErrors({ dateRangeError: true });
        minDateRangeControl.setErrors({ dateRangeError: true });
        return { dateRangeError: true };
      }
      else if(maxDateRange >= minDateRange){
        maxDateRangeControl.setErrors(null)
        minDateRangeControl.setErrors(null)
      }
    }
    return null;
  }
  
  collapseMenu() {
    this.updateShowMenuStatus(false);
    this.showMenuGroup.patchValue({
      showMenu: false,
    });
  }

  // Reject negative values and leading zeros
  onFontSizeChange(event: Event, formGroup: FormGroup) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    // Allow only numeric characters and remove leading zeros
    const correctedValue = value.replace(/[^0-9]/g, '').replace(/^0+/, '');

    formGroup.get('fontSize')?.setValue(correctedValue);
  }

  // Set a default value when the input loses focus with empty field
  onFontSizeBlur(event: Event, formGroup: FormGroup) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    // If the field is empty or contains only invalid input, set default
    if (value === '' || value === '0') {
      const defaultValue = 16; // Default value
      formGroup.get('fontSize')?.setValue(defaultValue);
    }
  }

    
  copyToClipboard(downLoadURL: string) {
    this.clipboard.copy(downLoadURL);
  }

  openMediaPopUp(event:any){
    const dialogRef =  this.dialog.open(MediaComponent,{
        height: '80vh',
        width: '90vw',
        autoFocus: false,
        data:{
          image:this.selectedWidgetMetaData.widgetConfig['image'].split('?')[0] ?? this.selectedWidgetMetaData.widgetConfig['image'],
          blobName:this.selectedWidgetMetaData.widgetConfig['additionalConfig']?.imagePath ?? null,
        }
      })

    dialogRef.afterClosed().subscribe(async (result:any) => {
      if (result && result?.proceed) {
        this.imageUploaderSrc = result.image.resource_url;
        let selectedImage = result.image;
        if (this.page.pageId) {
          let widgetId = this.selectedWidgetMetaData.widgetId;
          let updating = false;
          let image = '';
          if(this.selectedWidgetMetaData.widgetType === this.widgetTypes.chatBot) {
            image = this.selectedWidgetMetaData.widgetConfig?.additionalConfig?.uploadedAvatar ?? ''; 
            this.chatBotConfigurationForm.get('avatarFileName')?.patchValue(selectedImage.name)
          }
          else {
            image = this.selectedWidgetMetaData.widgetConfig.image ? this.selectedWidgetMetaData.widgetConfig.image : '';
          }
          updating = image.includes('mobiwise.s3')
          const parts: string[] = image.split('/');
            this.spinnerActive = false;
            if(this.selectedWidgetMetaData.widgetType === this.widgetTypes.chatBot) {
              let result : any = await this.sharedService.updateWidgetImage(selectedImage, widgetId,updating ? parts[parts.length - 1]:undefined );
              if(result.status){
                this.chatBotConfigurationForm.get('uploadedAvatar')?.patchValue(result.response.image);
                this.selectedWidgetMetaData.widgetConfig.additionalConfig.uploadedAvatar = result.response.image;
                this.s3ImageUrl = result.response.image +'?time='+new Date().getTime();
              }else{
                this.toasterService.error('Failed to upload image,please try again')
              }
            } else {
              this.s3ImageUrl = this.imageUploaderSrc + '?'+selectedImage.resource_version;
              this.selectedWidgetMetaData.widgetConfig['image'] = this.imageUploaderSrc;
              this.selectedWidgetMetaData.widgetConfig['additionalConfig']['resourceId'] = selectedImage.resource_id;
              this.selectedWidgetMetaData.widgetConfig['additionalConfig']['resourceVersion'] = selectedImage.resource_version;
              this.selectedWidgetMetaData.widgetConfig['additionalConfig']['imagePath'] = selectedImage?.resource_blob ?? '';
              this.selectedWidgetMetaData.widgetConfig['additionalConfig']['image'] = this.imageUploaderSrc;
              this.loading = true;
              this.getImageFile(this.selectedWidgetMetaData);
            }
        }
      }
    });

  }


  //#region charts 

  updateDiplayWidgetValues() {
    let chartConfig = structuredClone(this.chartDetailsFormGroup.value);
    if (this.selectedWidgetMetaData.widgetType !== WIDGET_TYPES.fixedBarChart) {
      chartConfig.yAxisProperties.series = chartConfig?.yAxisProperties?.individualSeriesProperties;
    }
    delete chartConfig?.yAxisProperties?.individualSeriesProperties;
    let widget = structuredClone(this.selectedWidgetMetaData);
    widget.widgetConfig.chartConfig = chartConfig;
    delete widget.widgetConfig.chartDataSourceData;
    this.highchartService.SetUpdatedDisplayWidgetDataConfig(true);
    const widgetPostData = {
      applicationId: this.applicationId,
      widgetConfig: widget.widgetConfig,
      widgetDataSource: widget.widgetDataSource,
      widgetLabel: widget.widgetLabel,
      userId: JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      widgetId: this.widgetId,
    }
    this.sharedService.updateWidget(widgetPostData, this.selectedWidgetMetaData.widgetId).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
    })

  }

  async getApiOrEntityDefinitionBasedOnForm(type: string, selectedId: string) {
    try {
      if (type === 'api' && selectedId) {
        let api = this.userApis.find((item:any) => item.apiId == selectedId);
        if(api){
          this.predefinedSelected = false;
           let apiResponce:any = await this.apiConfigService.makeDataSourceApiRequest(api.apiURL, api.method, api.requestBody, api.headers)
          if(apiResponce){
            this.handleResponse(apiResponce); this.addDataSource(true,api.apiId,'api');
          }
        }else{
          api = this.preConfiguredApis.find((item:any) => item.apiId == selectedId);
          this.predefinedSelected = true;
          this.handleResponse(api.apiResponce); this.addDataSource(true,selectedId,'api')
        }
      }
      else if (type === 'entity' && selectedId) {
        const entityId = selectedId;
        const entitySubmissionData = await this.wformService.getEntitySubmissionData(entityId).toPromise();
        this.handleResponse(entitySubmissionData);
        this.addDataSource(true,entityId,'entity')
      }
    }
    catch (error: any) {
      this.handleApiError(error);
    }
  }

  handleResponse(response: any) {
    let sourceData: any[] = []
    let widgetConfig =   this.selectedWidgetMetaData.widgetConfig
    if (Array.isArray(response) && response.length > 0) {
      this.apikeys = Object.keys(response[0]);
      sourceData = response;
    }
    else if (typeof (response) === 'object' && Array.isArray(response.data) && response.data.length > 0) {
      this.apikeys = Object.keys(response.data[0])
      sourceData = response.data;
    }
    else {
      this.toasterService.warning('The Api Does not return list of values');
    }

    widgetConfig.chartDataSourceData = sourceData;
  }

  addOrEditDatSourceConfig(type: string, template: TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      width: "600px"
    })
  }

  selectedShape(shape:string) {
    this.chatBotConfigurationForm.get('avatarShape')?.patchValue(shape);
  }

  selectedImage() {
    return this.chatBotConfigurationForm.value.uploadedAvatar ? this.chatBotConfigurationForm.value.uploadedAvatar : this.defaultAvtarImageUrl;
  }

  removeFile() {
    this.chatBotConfigurationForm.get('uploadedAvatar')?.setValue('');
    this.chatBotConfigurationForm.get('avatarFileName')?.setValue('');
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('fileInput');
    fileInput?.click();
  }

  get isChatBotFormEnabled() {
    const { showAttachmentsIcon, showTextInput, showSpeechIcon, showSendIcon, panelHeight } = this.chatBotConfigurationForm.value;
    return (showAttachmentsIcon || showTextInput || showSpeechIcon || showSendIcon) &&  (panelHeight >= 400);
  }

  onDataBoardApiSeletion(event:any){
    this.makeApiCall({},event.value);
    this.dataBoardGroup.get('widgetId')?.reset();
    if(event.value === "dashBoardWorkflowBased"){
      this.dataBoardGroup.get('widgetId')?.addValidators(Validators.required);
      this.dataBoardGroup.get('widgetId')?.updateValueAndValidity();
    }else{
      this.dataBoardGroup.get('widgetId')?.clearValidators();
      this.dataBoardGroup.get('widgetId')?.updateValueAndValidity();
    }
  }

  addFilter(){
    if(this.filterGroup.valid){
      let filterConfig = this.filterGroup.getRawValue();
      if(filterConfig.filterType === 'date_range'){
        filterConfig.manualValues = [];
        filterConfig.manual = false;
      }
      filterConfig["basedOn"] = this.filterGroupBasedOnFormatter(filterConfig?.basedOn,'string') ?? ""
      if(this.selectedWidgetMetaData.widgetConfig?.filters){
        this.selectedWidgetMetaData.widgetConfig.filters.push(filterConfig);
      }else{
        this.selectedWidgetMetaData.widgetConfig.filters = [filterConfig];
      }
      this.filterGroup.reset();
    }
  }
  
  async patchFilterwidget(filter:any,update:boolean){
    if(update){
      filter.sourceType == 'entity' ? await this.onEntitySelected({value:filter.dataSource},true) : this.makeApiCall({},filter.dataSource);
      filter["basedOn"] = this.filterGroupBasedOnFormatter(filter?.basedOn,'list') ?? ""
      this.filterUpdateGroup.patchValue(filter);
    }
  }

  filterBasedOnOptions(event:any,filterType:string){
    if(filterType === this.filterWidgetFilterTypes[0].id){
      // dropdown filter type
      this.filterBasedOnfiledWidgetOptions = this.dataBoardEntityBasedWidgets.filter((widget:any) => widget.widgetType !== this.widgetTypes.date);
    }else if(filterType === this.filterWidgetFilterTypes[1].id){
      // date_range filter type
      this.filterBasedOnfiledWidgetOptions = this.dataBoardEntityBasedWidgets.filter((widget:any) => ['user_id','stage_id','stage_status',this.widgetTypes.date].includes(widget.widgetType));
    }else{
      this.filterBasedOnfiledWidgetOptions = this.dataBoardEntityBasedWidgets
    }
  }

  filterGroupBasedOnFormatter(basedOnValue: any,type:string): string | string[] {
    let value : any = basedOnValue
    if (type === 'list' && typeof basedOnValue === "string") {
      // Convert string to list
      value = basedOnValue
        .split(',')
        .map((item:string) => item.trim())
        .filter((item:any) => item.length > 0);
    } else if (type === "string" && Array.isArray(basedOnValue)) {
      // Convert list to string
      value = basedOnValue
        .map((item:string) => item.trim())
        .filter((item:any) => item.length > 0)
        .join(', ');
    }

    return value;

  }

  addCustomValue(formGroup:FormGroup,formControlName:string,newValue:string){
    if(newValue != ''){
      let customValues: any = formGroup.get(formControlName)?.value;
      customValues ? customValues.push(newValue) : customValues = [newValue];
      
      formGroup.get(formControlName)?.patchValue(customValues);
    }
  }

  removeCustomValue(formGroup:FormGroup,formControlName:string,index:number){
      let customValues: string[] = formGroup.get(formControlName)?.value;
      customValues.splice(index,1);
      formGroup.get(formControlName)?.patchValue(customValues);
  }

  removeFilter(filterIndex:number){
    this.selectedWidgetMetaData.widgetConfig.filters.splice(filterIndex,1);
  }

  updateFilter(index:number,filterformGroup:FormGroup){
    let filterConfig = filterformGroup.getRawValue();
    if(filterConfig.filterType === 'date_range'){
      filterConfig.manualValues = [];
      filterConfig.manual = false;
    }
    this.selectedWidgetMetaData.widgetConfig.filters[index] = filterConfig;
    this.updateWidgetValues()
  }
}
